export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  DateTimeISO: { input: string; output: string; }
};

export type AddPostCardReplyUnion = {
  __typename?: 'AddPostCardReplyUnion';
  /** открытки к цветам */
  data?: Maybe<PostCardUnion>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type AddresItem = {
  /** опции комментария для заказа */
  comment?: InputMaybe<Array<CommentsItemInput>>;
  /** id адресса */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AndroidUnion = {
  __typename?: 'AndroidUnion';
  /** ... */
  intent?: Maybe<Scalars['String']['output']>;
  /** ссылка */
  link?: Maybe<Scalars['String']['output']>;
  /** сборка */
  package?: Maybe<Scalars['String']['output']>;
};

export type ApiErrorUnion = {
  __typename?: 'ApiErrorUnion';
  location?: Maybe<Scalars['String']['output']>;
  msg?: Maybe<Scalars['String']['output']>;
  param?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AppliedFilters = {
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  highRating?: InputMaybe<Scalars['Boolean']['input']>;
  hits?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  newbee?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplyPromocodeReplyUnion = {
  __typename?: 'ApplyPromocodeReplyUnion';
  /** корзина */
  cart?: Maybe<CartModel>;
  /** промокод */
  cartPromoCode?: Maybe<CartPromocodesModel>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type AreasModel = {
  __typename?: 'AreasModel';
  active?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** время доставки от */
  delivery_time_from?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  /** минимальная сумма */
  minimum_amount?: Maybe<Scalars['Float']['output']>;
  /** минимальный интервал от */
  minimum_interval_from?: Maybe<Scalars['Float']['output']>;
  /** оформите заказ до */
  order_deadline?: Maybe<Scalars['String']['output']>;
  seo_description?: Maybe<Scalars['String']['output']>;
  seo_keywords?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_short?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArticlesCommentsModel = {
  __typename?: 'ArticlesCommentsModel';
  active?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerUserItem?: Maybe<UsersModel>;
  answer_date?: Maybe<Scalars['DateTimeISO']['output']>;
  answer_user_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item_id?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ArticlesModel = {
  __typename?: 'ArticlesModel';
  _votedRating?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  attachmentsStretchItem?: Maybe<AttachmentsModel>;
  attachmentsVideoItem?: Maybe<AttachmentsModel>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  commentsItem?: Maybe<Array<ArticlesCommentsModel>>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['DateTimeISO']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  rating_votes?: Maybe<Scalars['Float']['output']>;
  recipesList?: Maybe<Array<RecipesModel>>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  stretch_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  video_code?: Maybe<Scalars['String']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
  video_title?: Maybe<Scalars['String']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
  zen_description?: Maybe<Scalars['String']['output']>;
  zen_media_rating?: Maybe<Scalars['Int']['output']>;
};

export type ArticlesUnion = {
  __typename?: 'ArticlesUnion';
  articlesComments?: Maybe<Array<ArticlesCommentsModel>>;
  articlesItems?: Maybe<Array<ArticlesModel>>;
  totalCount: Scalars['Int']['output'];
};

export type AttachmentsCacheModel = {
  __typename?: 'AttachmentsCacheModel';
  file?: Maybe<Scalars['String']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  filePath?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  file_webp?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Float']['output']>;
  filetype?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type AttachmentsModel = {
  __typename?: 'AttachmentsModel';
  bannerItem?: Maybe<Array<BannersModel>>;
  cacheItem?: Maybe<Array<AttachmentsCacheModel>>;
  converted?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  file_old?: Maybe<Scalars['String']['output']>;
  file_webp?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Float']['output']>;
  filetype?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isVideo?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  preview_id?: Maybe<Scalars['Float']['output']>;
  stretchFilePath: Scalars['String']['output'];
  tempFullFilePath: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  tmp?: Maybe<Scalars['Float']['output']>;
  typeItems?: Maybe<Array<AttachmentsTypesModel>>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type AttachmentsRelationsModel = {
  __typename?: 'AttachmentsRelationsModel';
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  typeItems?: Maybe<AttachmentsTypesModel>;
  type_id?: Maybe<Scalars['Float']['output']>;
};

export type AttachmentsTypesModel = {
  __typename?: 'AttachmentsTypesModel';
  active?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AvailableFilters = {
  __typename?: 'AvailableFilters';
  discount?: Maybe<Scalars['Boolean']['output']>;
  highRating?: Maybe<Scalars['Boolean']['output']>;
  hits?: Maybe<Scalars['Boolean']['output']>;
  maxPrice?: Maybe<Scalars['Boolean']['output']>;
  minPrice?: Maybe<Scalars['Boolean']['output']>;
  newbee?: Maybe<Scalars['Boolean']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
};

export type AvatarInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type BadgesCatalogModel = {
  __typename?: 'BadgesCatalogModel';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type BanksUnion = {
  __typename?: 'BanksUnion';
  /** android */
  android?: Maybe<AndroidUnion>;
  /** картинка */
  image?: Maybe<Scalars['String']['output']>;
  /** ios */
  ios?: Maybe<IosUnion>;
  /** есть ли поддержка? */
  support?: Maybe<Scalars['Boolean']['output']>;
  /** наименование банка */
  title?: Maybe<Scalars['String']['output']>;
};

export type BannersModel = {
  __typename?: 'BannersModel';
  active?: Maybe<Scalars['String']['output']>;
  bannerFilePath?: Maybe<Scalars['String']['output']>;
  catalogItems?: Maybe<Array<CatalogModel>>;
  catalogTypes?: Maybe<Array<CatalogTypesModel>>;
  catalog_type_id?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  default_banner?: Maybe<Scalars['String']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  file_new?: Maybe<Scalars['String']['output']>;
  for_all?: Maybe<Scalars['String']['output']>;
  for_unauth?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['String']['output']>;
  peopleProfiles?: Maybe<Array<PeopleProfileModel>>;
  position?: Maybe<Scalars['Float']['output']>;
  product_title?: Maybe<Scalars['String']['output']>;
  profile_id?: Maybe<Scalars['Int']['output']>;
  promotionItem?: Maybe<PromotionsModel>;
  promotion_id?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
  status_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BlogModel = {
  __typename?: 'BlogModel';
  active?: Maybe<Scalars['String']['output']>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  author?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  interesting?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['DateTimeISO']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  stretchItem?: Maybe<AttachmentsModel>;
  stretch_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  typeItem?: Maybe<BlogTypesModel>;
  type_id?: Maybe<Scalars['Int']['output']>;
};

export type BlogTypesModel = {
  __typename?: 'BlogTypesModel';
  active?: Maybe<Scalars['String']['output']>;
  blogItems?: Maybe<Array<BlogModel>>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  modified_at?: Maybe<Scalars['DateTimeISO']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type BonusesInput = {
  pay_over_weight_with_bonuses?: InputMaybe<Scalars['Boolean']['input']>;
  pay_tip_with_bonuses?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CabinetUnion = {
  __typename?: 'CabinetUnion';
  allStatuses?: Maybe<Array<PeopleStatusModel>>;
  billLogItems?: Maybe<Array<PeopleBillLogModel>>;
  bludoItems?: Maybe<Array<RecipesBludoModel>>;
  cabinetSettings?: Maybe<PeopleSettingsModel>;
  cabinetTemplatesItems?: Maybe<Array<CartTemplatesUnion>>;
  catalogItems?: Maybe<Array<CatalogModel>>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  orderItem?: Maybe<OrdersModel>;
  orderThatUserCanChange?: Maybe<OrdersModel>;
  ordersList?: Maybe<Array<OrdersModel>>;
  ordersThatUserCanChange?: Maybe<Array<OrdersUnion>>;
  peopleItem?: Maybe<PeopleModel>;
  peopleProfileItems?: Maybe<Array<PeopleProfileModel>>;
  peopleSubscribs?: Maybe<SubscribersModel>;
  recipesItem?: Maybe<Array<RecipesModel>>;
  reply?: Maybe<ReplyUnion>;
  rubricMenuTree?: Maybe<Array<CatalogTypesModel>>;
  statusId?: Maybe<Scalars['Int']['output']>;
  testDrive?: Maybe<Scalars['Boolean']['output']>;
  testDriveItem?: Maybe<TestDriveSubscribersModel>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalOrdersPrice?: Maybe<Scalars['Int']['output']>;
};

export type CabitetEditReviewReplyUnion = {
  __typename?: 'CabitetEditReviewReplyUnion';
  commentItem?: Maybe<CatalogCommentsModel>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  reviewFromHostory?: Maybe<ReviewsHistoryModel>;
  reviewItem?: Maybe<ReviewsModel>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type CabitetReviewsReplyUnion = {
  __typename?: 'CabitetReviewsReplyUnion';
  commentsItems?: Maybe<Array<CatalogCommentsModel>>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  reviewsItems?: Maybe<Array<ReviewsModel>>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type Caches = {
  __typename?: 'Caches';
  key?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  secondsBeforDie?: Maybe<Scalars['Float']['output']>;
};

export type CardInput = {
  accept_auto_payment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartItemsModel = {
  __typename?: 'CartItemsModel';
  amount?: Maybe<Scalars['Float']['output']>;
  cartItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalogKitItem?: Maybe<CatalogKitModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  freeOfCharge?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  kit_id?: Maybe<Scalars['Int']['output']>;
  orderItem?: Maybe<OrdersItemsModel>;
  order_item_id?: Maybe<Scalars['Int']['output']>;
  postcards?: Maybe<Array<CartPostcardsModel>>;
  product?: Maybe<CatalogModel>;
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CartLoyaltyProgramModel = {
  __typename?: 'CartLoyaltyProgramModel';
  cartItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  freeDelivery?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  is_free_delivery?: Maybe<Scalars['Float']['output']>;
  loyaltyProgram?: Maybe<LoyaltyProgramModel>;
  loyaltyProgramItem?: Maybe<LoyaltyProgramModel>;
  loyalty_program_id?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<CatalogModel>;
  productItem?: Maybe<CatalogModel>;
  product_id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<ServicesModel>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
};

export type CartModel = {
  __typename?: 'CartModel';
  addressConfirmedByUser?: Maybe<Scalars['Boolean']['output']>;
  addressItem?: Maybe<PeopleAddressesModel>;
  address_id?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  billPayed?: Maybe<Scalars['Int']['output']>;
  bill_payed?: Maybe<Scalars['Float']['output']>;
  cartItems?: Maybe<Array<CartItemsModel>>;
  cartLoyaltyProgram?: Maybe<Array<CartLoyaltyProgramModel>>;
  cartLoyaltyProgramItems?: Maybe<Array<CartLoyaltyProgramModel>>;
  cartPromocodes?: Maybe<Array<CartPromocodesModel>>;
  cartServicesItems?: Maybe<Array<CartServicesModel>>;
  cartTestDrive?: Maybe<CartTestDrivesModel>;
  cartTestDriveItem?: Maybe<CartTestDrivesModel>;
  cityItem?: Maybe<OrdersCitiesModel>;
  city_id?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  cookieId: Scalars['String']['output'];
  cookie_id?: Maybe<Scalars['String']['output']>;
  coords?: Maybe<Scalars['String']['output']>;
  dadata?: Maybe<DadataModel>;
  dadataItem?: Maybe<DadataModel>;
  dadata_id?: Maybe<Scalars['Int']['output']>;
  deliveryCost?: Maybe<Scalars['Int']['output']>;
  deliveryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryIntervalEnd?: Maybe<Scalars['Int']['output']>;
  deliveryIntervalId?: Maybe<Scalars['Int']['output']>;
  deliveryIntervalStart?: Maybe<Scalars['Int']['output']>;
  deliveryItem?: Maybe<OrdersDeliveryModel>;
  delivery_cost?: Maybe<Scalars['Float']['output']>;
  delivery_date?: Maybe<Scalars['DateTimeISO']['output']>;
  delivery_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  getCartPossibleBonus?: Maybe<CartUnion>;
  /** Подарки в корзине */
  gifts?: Maybe<Array<CatalogModel>>;
  id: Scalars['ID']['output'];
  interval_end?: Maybe<Scalars['Float']['output']>;
  interval_id?: Maybe<Scalars['Float']['output']>;
  interval_start?: Maybe<Scalars['Float']['output']>;
  is_menu?: Maybe<Scalars['Int']['output']>;
  /** Товарные позиции */
  items?: Maybe<Array<CartItemsModel>>;
  menu_people_id?: Maybe<Scalars['Int']['output']>;
  minAllowableTotal?: Maybe<Scalars['Int']['output']>;
  needReceipt?: Maybe<Scalars['Int']['output']>;
  need_receipt?: Maybe<Scalars['Float']['output']>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  payment?: Maybe<OrdersPaymentsModel>;
  paymentItem?: Maybe<OrdersPaymentsModel>;
  payment_id?: Maybe<Scalars['Int']['output']>;
  people?: Maybe<PeopleModel>;
  peopleAddress?: Maybe<PeopleAddressesModel>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Возможный бонус */
  possibleBonus?: Maybe<PossibleBonusUnion>;
  price?: Maybe<Scalars['Float']['output']>;
  promoCodes?: Maybe<Array<CartPromocodesModel>>;
  promocodeItem?: Maybe<PromocodesModel>;
  promocode_id?: Maybe<Scalars['Int']['output']>;
  services?: Maybe<Array<CartServicesModel>>;
  storeItem: StoresModel;
  store_id: Scalars['Int']['output'];
  street?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  testDriveItem?: Maybe<CartTestDrivesModel>;
  /** Тест-драйвы, на участие в которых можно подать заявку */
  testDrives?: Maybe<Array<TestDriveModel>>;
  timeid?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  /** Итого с учётом стоимости доставки */
  totalWithDeliveryPrice?: Maybe<Scalars['Int']['output']>;
};

export type CartPostcardsModel = {
  __typename?: 'CartPostcardsModel';
  cartItem?: Maybe<CartModel>;
  cartItemsItem?: Maybe<CartItemsModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  cart_item_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  sender?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CartPromocodesModel = {
  __typename?: 'CartPromocodesModel';
  actual?: Maybe<Scalars['Int']['output']>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  is_actual?: Maybe<Scalars['Int']['output']>;
  promoCode?: Maybe<PromocodesModel>;
  promocodeItem?: Maybe<PromocodesModel>;
  promocode_id?: Maybe<Scalars['Int']['output']>;
};

export type CartRecommendUnion = {
  __typename?: 'CartRecommendUnion';
  items?: Maybe<Array<CatalogModel>>;
  title?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export type CartServicesModel = {
  __typename?: 'CartServicesModel';
  amount?: Maybe<Scalars['Float']['output']>;
  cartItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  is_for_manager?: Maybe<Scalars['Int']['output']>;
  is_subscription?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<ServicesModel>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
  subscription?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CartShareDataUnion = {
  __typename?: 'CartShareDataUnion';
  cartItems?: Maybe<Array<CartShareItemsUnion>>;
  cartToken?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CartShareItemsModel = {
  __typename?: 'CartShareItemsModel';
  cartShareItem?: Maybe<CartShareModel>;
  cart_share_id?: Maybe<Scalars['Int']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  kit_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type CartShareItemsUnion = {
  __typename?: 'CartShareItemsUnion';
  amount?: Maybe<Scalars['Int']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
};

export type CartShareModel = {
  __typename?: 'CartShareModel';
  code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  items?: Maybe<Array<CartShareItemsModel>>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CartTemplateItemsModel = {
  __typename?: 'CartTemplateItemsModel';
  cartTemplateItem?: Maybe<CartTemplateModel>;
  cart_template_id?: Maybe<Scalars['Int']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kit_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type CartTemplateModel = {
  __typename?: 'CartTemplateModel';
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  templateItemsList?: Maybe<Array<CartTemplateItemsModel>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CartTemplatesSatatusesUnion = {
  __typename?: 'CartTemplatesSatatusesUnion';
  amount: Scalars['Float']['output'];
  list: Array<CartTemplateItemsModel>;
  quantity: Scalars['Int']['output'];
};

export type CartTemplatesUnion = {
  __typename?: 'CartTemplatesUnion';
  available?: Maybe<CartTemplatesSatatusesUnion>;
  date: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  unavailable?: Maybe<CartTemplatesSatatusesUnion>;
};

export type CartTestDrivesModel = {
  __typename?: 'CartTestDrivesModel';
  cartItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  testDrive?: Maybe<TestDriveModel>;
  testDriveItem?: Maybe<TestDriveModel>;
  test_drive_id?: Maybe<Scalars['Int']['output']>;
};

export type CartUnion = {
  __typename?: 'CartUnion';
  loyaltyProgram?: Maybe<LoyaltyProgramModel>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  priceDifference?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CatalogAmountsModel = {
  __typename?: 'CatalogAmountsModel';
  amount: Scalars['Float']['output'];
  catalogItem?: Maybe<CatalogModel>;
  date: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  storeItem?: Maybe<StoresModel>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

export type CatalogAnalogsUnion = {
  __typename?: 'CatalogAnalogsUnion';
  catalogAnalogs?: Maybe<Array<CatalogModel>>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CatalogBadgesRubricsUnion = {
  __typename?: 'CatalogBadgesRubricsUnion';
  discount?: Maybe<CatalogBadgesUnion>;
  hit?: Maybe<CatalogBadgesUnion>;
  natural?: Maybe<CatalogBadgesUnion>;
  newbee?: Maybe<CatalogBadgesUnion>;
  promotion?: Maybe<CatalogBadgesUnion>;
  superprice?: Maybe<CatalogBadgesUnion>;
};

export type CatalogBadgesUnion = {
  __typename?: 'CatalogBadgesUnion';
  available?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CatalogBreadUnion = {
  __typename?: 'CatalogBreadUnion';
  binding?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CatalogCommentsModel = {
  __typename?: 'CatalogCommentsModel';
  _voted?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerUserItem?: Maybe<UsersModel>;
  answer_date?: Maybe<Scalars['DateTimeISO']['output']>;
  answer_rating?: Maybe<Scalars['Float']['output']>;
  answer_rating_text?: Maybe<Scalars['String']['output']>;
  answer_user_id?: Maybe<Scalars['Int']['output']>;
  auto_fixed_date?: Maybe<Scalars['DateTimeISO']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  fixed_date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  isCanEdit?: Maybe<Scalars['Boolean']['output']>;
  isCanRateAnswer?: Maybe<Scalars['Boolean']['output']>;
  is_auto_fixed?: Maybe<Scalars['Float']['output']>;
  is_fixed?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<CommentsPhotosUnion>>;
  rating?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  test_drive_id?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  votes_no?: Maybe<Scalars['Float']['output']>;
  votes_yes?: Maybe<Scalars['Float']['output']>;
};

export type CatalogDeliveryUnion = {
  __typename?: 'CatalogDeliveryUnion';
  available?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  date_with_timezone?: Maybe<Scalars['DateTimeISO']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  day_month?: Maybe<Scalars['String']['output']>;
  day_month_weekday_full?: Maybe<Scalars['String']['output']>;
  day_month_weekday_short?: Maybe<Scalars['String']['output']>;
  day_of_week?: Maybe<Scalars['String']['output']>;
  dom?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  is_nearest?: Maybe<Scalars['Boolean']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  nextFreeInterval?: Maybe<Scalars['Boolean']['output']>;
  nextFreeIntervalItem?: Maybe<CatalogDeliveryUnion>;
  price?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['DateTimeISO']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleFull?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  will_be_closed?: Maybe<Scalars['Float']['output']>;
};

export type CatalogFaqItemUnion = {
  __typename?: 'CatalogFaqItemUnion';
  answer?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CatalogFieldsModel = {
  __typename?: 'CatalogFieldsModel';
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CatalogImgUnion = {
  __typename?: 'CatalogImgUnion';
  big?: Maybe<Array<Scalars['String']['output']>>;
  original?: Maybe<Array<Scalars['String']['output']>>;
  productId?: Maybe<Scalars['Float']['output']>;
  raw?: Maybe<Array<Scalars['String']['output']>>;
  small?: Maybe<Array<Scalars['String']['output']>>;
  square?: Maybe<Array<Scalars['String']['output']>>;
};

export type CatalogKitModel = {
  __typename?: 'CatalogKitModel';
  active?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  catalogList?: Maybe<Array<CatalogModel>>;
  comments_number?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  is_ready_set?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  promotion_id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  sales_number?: Maybe<Scalars['Float']['output']>;
  special_conditions?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CatalogMeasuresModel = {
  __typename?: 'CatalogMeasuresModel';
  active?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CatalogModel = {
  __typename?: 'CatalogModel';
  attributes: Array<ProductAttributeType>;
  _rubricWeight?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  alsobought?: Maybe<Array<CatalogModel>>;
  archive?: Maybe<Scalars['String']['output']>;
  /** Время сборки товара на складе */
  assemblyTime?: Maybe<Scalars['Float']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  availableQuantity?: Maybe<Array<CatalogAmountsModel>>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  badges?: Maybe<CatalogBadgesRubricsUnion>;
  badgesList?: Maybe<Array<BadgesCatalogModel>>;
  bonus_points?: Maybe<Scalars['Float']['output']>;
  bread?: Maybe<Array<CatalogBreadUnion>>;
  canAddReviewComment?: Maybe<Scalars['Boolean']['output']>;
  /** покупал ли пользователь товар и может ему ставить оценку -> Реализовано в сущночти комментария getProductCommentsById => productPeopleBuy */
  canRate?: Maybe<Scalars['Boolean']['output']>;
  carbs?: Maybe<Scalars['String']['output']>;
  cartItemId?: Maybe<Scalars['Int']['output']>;
  catalogAnalogs?: Maybe<Array<CatalogModel>>;
  catalogPossibleBonus?: Maybe<Scalars['String']['output']>;
  checkImages: Scalars['Boolean']['output'];
  check_amount?: Maybe<Scalars['String']['output']>;
  classified_id?: Maybe<Scalars['String']['output']>;
  commentsList?: Maybe<Array<CatalogCommentsModel>>;
  comments_number?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  ctg_id?: Maybe<Scalars['Float']['output']>;
  currentPriceField?: Maybe<Scalars['Float']['output']>;
  currentPriceField2?: Maybe<Scalars['Float']['output']>;
  currentUser?: Maybe<PeopleModel>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  delivery?: Maybe<CatalogDeliveryUnion>;
  delivery_day?: Maybe<Scalars['String']['output']>;
  delivery_days?: Maybe<Scalars['String']['output']>;
  delivery_text?: Maybe<Scalars['String']['output']>;
  delivery_time?: Maybe<Scalars['Float']['output']>;
  delivery_type?: Maybe<Scalars['String']['output']>;
  digital?: Maybe<Scalars['Int']['output']>;
  discounPriceField?: Maybe<Scalars['Float']['output']>;
  discounPriceField2?: Maybe<Scalars['Float']['output']>;
  dlv_id?: Maybe<Scalars['Float']['output']>;
  energy_value?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['String']['output']>;
  expiration_title?: Maybe<Scalars['String']['output']>;
  fats?: Maybe<Scalars['String']['output']>;
  favoritesList?: Maybe<Array<FavoritesModel>>;
  fieldsList?: Maybe<Array<CatalogFieldsModel>>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  filtersList?: Maybe<Array<CatalogTypeFiltersModel>>;
  gds_box?: Maybe<Scalars['Float']['output']>;
  gds_cntbeg?: Maybe<Scalars['Float']['output']>;
  gds_cntlen?: Maybe<Scalars['Float']['output']>;
  gds_code?: Maybe<Scalars['String']['output']>;
  gds_codebeg?: Maybe<Scalars['Float']['output']>;
  gds_codelen?: Maybe<Scalars['Float']['output']>;
  gds_control?: Maybe<Scalars['String']['output']>;
  gds_count?: Maybe<Scalars['Float']['output']>;
  gds_del?: Maybe<Scalars['String']['output']>;
  gds_descr?: Maybe<Scalars['String']['output']>;
  gds_enabled_old?: Maybe<Scalars['Float']['output']>;
  gds_expire?: Maybe<Scalars['Float']['output']>;
  gds_mincnt?: Maybe<Scalars['Float']['output']>;
  gds_mintype?: Maybe<Scalars['String']['output']>;
  gds_name?: Maybe<Scalars['String']['output']>;
  gds_nds?: Maybe<Scalars['Float']['output']>;
  gds_pack?: Maybe<Scalars['Float']['output']>;
  gds_packing?: Maybe<Scalars['Float']['output']>;
  gds_part?: Maybe<Scalars['Float']['output']>;
  gds_place?: Maybe<Scalars['String']['output']>;
  gds_price?: Maybe<Scalars['Float']['output']>;
  gds_prod1?: Maybe<Scalars['DateTimeISO']['output']>;
  gds_prod2?: Maybe<Scalars['DateTimeISO']['output']>;
  gds_psv?: Maybe<Scalars['String']['output']>;
  gds_psvto?: Maybe<Scalars['DateTimeISO']['output']>;
  gds_reserv?: Maybe<Scalars['Float']['output']>;
  gds_sertif?: Maybe<Scalars['DateTimeISO']['output']>;
  gds_warn?: Maybe<Scalars['Float']['output']>;
  gds_weight_old?: Maybe<Scalars['Float']['output']>;
  gds_wonds?: Maybe<Scalars['Float']['output']>;
  /** рецепты */
  getProductRecipesById?: Maybe<CustomRecipesUnion>;
  getURL?: Maybe<Scalars['String']['output']>;
  gost?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  group_is_main?: Maybe<Scalars['String']['output']>;
  /** есть ли рецепты для данного товара */
  hasRecipes?: Maybe<Scalars['Boolean']['output']>;
  hit?: Maybe<Scalars['String']['output']>;
  how_to_make?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  images?: Maybe<CatalogImgUnion>;
  inet_id_old?: Maybe<Scalars['Float']['output']>;
  inet_name?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Scalars['String']['output']>;
  isAvailableForPurchase?: Maybe<Scalars['Boolean']['output']>;
  isBigCard?: Maybe<Scalars['Boolean']['output']>;
  /** комментировал ли пользователь данный продукт */
  isCommented?: Maybe<Scalars['Boolean']['output']>;
  isExpressDeliveryAval?: Maybe<Scalars['Boolean']['output']>;
  isExpressPickupAval?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isInFavorites?: Maybe<Scalars['Boolean']['output']>;
  isMenu?: Maybe<Scalars['Boolean']['output']>;
  isNotForSaleBarMenu?: Maybe<Scalars['Boolean']['output']>;
  isPostponed?: Maybe<Scalars['Boolean']['output']>;
  isPromo?: Maybe<Scalars['Boolean']['output']>;
  isPromo1?: Maybe<Scalars['Boolean']['output']>;
  is_18plus?: Maybe<Scalars['Float']['output']>;
  is_digital_auto?: Maybe<Scalars['Int']['output']>;
  is_natural?: Maybe<Scalars['String']['output']>;
  is_not_for_index?: Maybe<Scalars['String']['output']>;
  is_not_for_sale?: Maybe<Scalars['String']['output']>;
  is_our?: Maybe<Scalars['Int']['output']>;
  is_pinned?: Maybe<Scalars['Float']['output']>;
  is_postcard_allowed?: Maybe<Scalars['Float']['output']>;
  kitList?: Maybe<Array<CatalogKitModel>>;
  link?: Maybe<Scalars['String']['output']>;
  mainBarRubric?: Maybe<CatalogTypesModel>;
  mainImage?: Maybe<Scalars['String']['output']>;
  mainRootRubric?: Maybe<CatalogTypesModel>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  maxPurchase?: Maybe<Scalars['Int']['output']>;
  max_purchase?: Maybe<Scalars['Float']['output']>;
  measureItem?: Maybe<CatalogMeasuresModel>;
  measure_id?: Maybe<Scalars['Int']['output']>;
  modify_date?: Maybe<Scalars['DateTimeISO']['output']>;
  mostUsefulComment?: Maybe<CatalogCommentsModel>;
  multiPrices?: Maybe<Array<CatalogMultiPricesModel>>;
  nearestDelivery?: Maybe<CatalogDeliveryUnion>;
  /** Количество товара, доступное на ближайшую дату доставки */
  nearestDeliveryAmount?: Maybe<Scalars['Float']['output']>;
  newbee?: Maybe<Scalars['String']['output']>;
  nutritional_value?: Maybe<Scalars['String']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  oldPriceField?: Maybe<Scalars['Float']['output']>;
  oldPriceField2?: Maybe<Scalars['Float']['output']>;
  old_id?: Maybe<Scalars['Float']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  plc_id?: Maybe<Scalars['Float']['output']>;
  popular_main?: Maybe<Scalars['String']['output']>;
  postcardAllowed?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** нужно ли выводить верхний доп. блок с ценами */
  priceBlockWeightPrice?: Maybe<Scalars['Boolean']['output']>;
  price_active?: Maybe<Scalars['Float']['output']>;
  price_current?: Maybe<Scalars['Float']['output']>;
  price_kit?: Maybe<Scalars['Float']['output']>;
  price_promo?: Maybe<Scalars['Float']['output']>;
  price_retail?: Maybe<Scalars['Float']['output']>;
  price_sale?: Maybe<Scalars['Float']['output']>;
  price_wholesale?: Maybe<Scalars['Float']['output']>;
  /** improvements are required */
  productAdditionalInfo?: Maybe<ProductAdditionalInfoUnion>;
  /** Сообщить о скидке */
  productDiscountNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Сообщить о скидке */
  productDiscountNotificationOrigin?: Maybe<Scalars['Boolean']['output']>;
  productPhotoWrap?: Maybe<Scalars['String']['output']>;
  promocodeGiftItems?: Maybe<Array<PromocodesModel>>;
  promotionsItems?: Maybe<Array<PromotionsItemsModel>>;
  proteins?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  rating_comments?: Maybe<Scalars['Float']['output']>;
  recipes_text?: Maybe<Scalars['String']['output']>;
  recommend?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<CatalogModel>>;
  redirect?: Maybe<Scalars['String']['output']>;
  reference_weight?: Maybe<Scalars['String']['output']>;
  registryRecordUrl?: Maybe<Scalars['String']['output']>;
  registryRecordUrls?: Maybe<Array<Scalars['String']['output']>>;
  relFilter?: Maybe<Array<CatalogRelationsModel>>;
  relProfile?: Maybe<Array<CatalogRelationsModel>>;
  relType?: Maybe<Array<CatalogRelationsModel>>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
  sales_number?: Maybe<Scalars['Float']['output']>;
  seo?: Maybe<Array<CatalogSeoUnion>>;
  seo_auto?: Maybe<Scalars['Float']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  shortLink?: Maybe<Scalars['String']['output']>;
  show_recommendations?: Maybe<Scalars['String']['output']>;
  sizeRangeItem?: Maybe<CatalogSizeRangeModel>;
  size_range_id?: Maybe<Scalars['Int']['output']>;
  /** информация по связанных с этим товаром промокодов на спец цену */
  specialPriceData?: Maybe<CatalogSpecialPriceUnion>;
  special_conditions?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CatalogStatusesModel>;
  statusItem?: Maybe<CatalogStatusesModel>;
  status_id?: Maybe<Scalars['Int']['output']>;
  storage_conditions?: Maybe<Scalars['String']['output']>;
  storesProductPrices?: Maybe<Array<StoresProductPricesModel>>;
  storesStatusesList?: Maybe<Array<CatalogStoresStatusesModel>>;
  subProducts?: Maybe<Array<CatalogModel>>;
  subscribers?: Maybe<Array<CatalogSubscribersModel>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  superPrice?: Maybe<Scalars['String']['output']>;
  superprice?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['Float']['output']>;
  supply_title?: Maybe<Scalars['String']['output']>;
  symbolPriceField?: Maybe<Scalars['String']['output']>;
  symbolPriceField2?: Maybe<Scalars['String']['output']>;
  /** Задания для данного пользователя по данному продукту */
  taskItems?: Maybe<TasksReplyUnion>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  txt_groups?: Maybe<Scalars['String']['output']>;
  typesList?: Maybe<Array<CatalogTypesModel>>;
  unt_id_old?: Maybe<Scalars['Float']['output']>;
  variants?: Maybe<Array<CatalogModel>>;
  vesovoi?: Maybe<Scalars['String']['output']>;
  /** список видео, полученных из поля text */
  videoFromText?: Maybe<Array<Scalars['String']['output']>>;
  videoItem?: Maybe<AttachmentsModel>;
  video_code?: Maybe<Scalars['String']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
  video_title?: Maybe<Scalars['String']['output']>;
  video_youtube?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<VideosUnion>>;
  war_id?: Maybe<Scalars['Float']['output']>;
  weightOfGoods?: Maybe<Scalars['Float']['output']>;
  weightOfPacking?: Maybe<Scalars['Float']['output']>;
  weight_of_goods?: Maybe<Scalars['Float']['output']>;
  weight_of_packing?: Maybe<Scalars['Float']['output']>;
  /** список с данными по видио */
  youtubeVideos?: Maybe<Array<YouTubeUnion>>;
};

export type CatalogMultiPricesModel = {
  __typename?: 'CatalogMultiPricesModel';
  active?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  buy_at_once?: Maybe<Scalars['Float']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  gds_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pay_for?: Maybe<Scalars['Float']['output']>;
  price_active?: Maybe<Scalars['Float']['output']>;
  price_current?: Maybe<Scalars['Float']['output']>;
  price_retail?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  programm?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  staff?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  stop?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
  /** цены, учитывающие весовые значения товара, в ссответствии с МЦ */
  weightPriceData?: Maybe<CatalogSpecialPriceUnion>;
};

export type CatalogRelationsModel = {
  __typename?: 'CatalogRelationsModel';
  catalogItem: CatalogModel;
  filterItem: CatalogTypeFiltersModel;
  filter_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  profileItem: PeopleProfileModel;
  profile_id?: Maybe<Scalars['Float']['output']>;
  special_event_id?: Maybe<Scalars['Float']['output']>;
  spectypeItem: CatalogTypesModel;
  spectype_id?: Maybe<Scalars['Int']['output']>;
  typeItem: CatalogTypesModel;
  type_id?: Maybe<Scalars['Int']['output']>;
};

export type CatalogSeoUnion = {
  __typename?: 'CatalogSeoUnion';
  /** Максимальная цена */
  highPrice?: Maybe<Scalars['Float']['output']>;
  /** Минимальная цена */
  lowPrice?: Maybe<Scalars['Float']['output']>;
  /** Общее количество товаров */
  offerCount?: Maybe<Scalars['Float']['output']>;
  /** Рейтинги: средний */
  ratingValue?: Maybe<Scalars['Float']['output']>;
  /** Общее количество отзывов */
  reviewCount?: Maybe<Scalars['Float']['output']>;
};

export type CatalogSizeRangeModel = {
  __typename?: 'CatalogSizeRangeModel';
  id: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type_measure?: Maybe<Scalars['String']['output']>;
  type_name?: Maybe<Scalars['String']['output']>;
};

export type CatalogSpecialPriceUnion = {
  __typename?: 'CatalogSpecialPriceUnion';
  amount?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price1Kg?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CatalogStatusesModel = {
  __typename?: 'CatalogStatusesModel';
  id: Scalars['ID']['output'];
  is_search?: Maybe<Scalars['Float']['output']>;
  is_subscribe?: Maybe<Scalars['Float']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CatalogStoresStatusesModel = {
  __typename?: 'CatalogStoresStatusesModel';
  id: Scalars['Int']['output'];
  productItem?: Maybe<CatalogModel>;
  product_id?: Maybe<Scalars['Int']['output']>;
  statusItem?: Maybe<CatalogStatusesModel>;
  status_id?: Maybe<Scalars['Int']['output']>;
  storeItem?: Maybe<StoresModel>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

/** тип подписки */
export enum CatalogSubE {
  InStock = 'IN_STOCK',
  PriceDrop = 'PRICE_DROP'
}

export type CatalogSubsUnion = {
  __typename?: 'CatalogSubsUnion';
  inStock?: Maybe<Array<CatalogSubscribersModel>>;
  priceDrop?: Maybe<Array<CatalogSubscribersModel>>;
};

export type CatalogSubscribersModel = {
  __typename?: 'CatalogSubscribersModel';
  catalogItem?: Maybe<CatalogModel>;
  cookie_id?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  subedByEmail?: Maybe<Scalars['Boolean']['output']>;
  subedByPhone?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CatalogTypeFiltersModel = {
  __typename?: 'CatalogTypeFiltersModel';
  active?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  catalogList?: Maybe<Array<CatalogModel>>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  isAll?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parentItem?: Maybe<CatalogTypesModel>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  relFiltersList?: Maybe<Array<CatalogRelationsModel>>;
  rubticProductsCount?: Maybe<Scalars['Float']['output']>;
  seo_canonical?: Maybe<Scalars['String']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  short_title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesale_items?: Maybe<Scalars['Float']['output']>;
};

export type CatalogTypesModel = {
  __typename?: 'CatalogTypesModel';
  _parentIdentify?: Maybe<Scalars['String']['output']>;
  _productId?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  affiliate_title?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  badge_text?: Maybe<Scalars['String']['output']>;
  bg_color?: Maybe<Scalars['String']['output']>;
  big_cards?: Maybe<Scalars['Float']['output']>;
  children?: Maybe<Array<CatalogTypesModel>>;
  childrenItems?: Maybe<Array<CatalogTypesModel>>;
  children_ids?: Maybe<Scalars['String']['output']>;
  children_title?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Float']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  filterItems?: Maybe<Array<CatalogTypeFiltersModel>>;
  filter_title?: Maybe<Scalars['String']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  genitive?: Maybe<Scalars['String']['output']>;
  hit_count?: Maybe<Scalars['Float']['output']>;
  icon_hover_id?: Maybe<Scalars['Float']['output']>;
  icon_hover_url?: Maybe<Scalars['String']['output']>;
  icon_id?: Maybe<Scalars['Float']['output']>;
  icon_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  inflection?: Maybe<Scalars['String']['output']>;
  isAll?: Maybe<Scalars['Boolean']['output']>;
  is_menu?: Maybe<Scalars['Float']['output']>;
  is_not_for_index?: Maybe<Scalars['String']['output']>;
  is_not_for_sale?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  menu_type?: Maybe<Scalars['Float']['output']>;
  modified_at?: Maybe<Scalars['DateTimeISO']['output']>;
  natural_count?: Maybe<Scalars['Float']['output']>;
  newbee?: Maybe<Scalars['Float']['output']>;
  parentItem?: Maybe<CatalogTypesModel>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  parent_special?: Maybe<Scalars['String']['output']>;
  productsList?: Maybe<Array<CatalogModel>>;
  promo?: Maybe<Scalars['Float']['output']>;
  rubricGroup?: Maybe<Array<CatalogTypeFiltersModel>>;
  rubricGroupTitle?: Maybe<Scalars['String']['output']>;
  rubticProductsCount?: Maybe<Scalars['Float']['output']>;
  seo_canonical?: Maybe<Scalars['String']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_template_md?: Maybe<Scalars['String']['output']>;
  seo_template_mkw?: Maybe<Scalars['String']['output']>;
  seo_template_title?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  short_title?: Maybe<Scalars['String']['output']>;
  special?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalProducts?: Maybe<Scalars['Float']['output']>;
  typesItems?: Maybe<Array<CatalogTypesModel>>;
  uri?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesale_items?: Maybe<Scalars['Float']['output']>;
};

export type CatalogUnion = {
  __typename?: 'CatalogUnion';
  availableFilters?: Maybe<AvailableFilters>;
  catalogItems?: Maybe<Array<CatalogModel>>;
  catalogSeo?: Maybe<CatalogSeoUnion>;
  categories?: Maybe<Array<Categories>>;
  commentsItems?: Maybe<Array<CatalogCommentsModel>>;
  error?: Maybe<Scalars['String']['output']>;
  isAlreadyReviewed?: Maybe<Scalars['Boolean']['output']>;
  maxPrice?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  noExactProductFound?: Maybe<Scalars['Boolean']['output']>;
  popularCatalogItems?: Maybe<Array<CatalogModel>>;
  productPeopleBuy?: Maybe<Scalars['Boolean']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  reviewabilityStatus?: Maybe<ReviewabilityStatus>;
  rubricBanner?: Maybe<Scalars['String']['output']>;
  rubricBigCards?: Maybe<Scalars['Float']['output']>;
  rubricBreadcrumbs?: Maybe<Array<CatalogTypesModel>>;
  rubricGroup?: Maybe<Array<CatalogTypeFiltersModel>>;
  rubricGroupTitle?: Maybe<Scalars['String']['output']>;
  rubricMenuTree?: Maybe<Array<CatalogTypesModel>>;
  rubricParentIdentify?: Maybe<Scalars['String']['output']>;
  rubricParentItem?: Maybe<CatalogTypesModel>;
  rubricText?: Maybe<Scalars['String']['output']>;
  rubricTitle?: Maybe<Scalars['String']['output']>;
  rubricTypes?: Maybe<Array<CatalogTypesModel>>;
  rubricTypesTile?: Maybe<Scalars['String']['output']>;
  setLimit?: Maybe<Scalars['Float']['output']>;
  setOrder?: Maybe<Scalars['String']['output']>;
  tips?: Maybe<Array<Tips>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  userReviewRating?: Maybe<Scalars['Float']['output']>;
};

export type Categories = {
  __typename?: 'Categories';
  hits?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Comment = {
  __typename?: 'Comment';
  comment?: Maybe<CommentsModel>;
  option?: Maybe<CommentsListOptionsModel>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CommentOrReviewInput = {
  /** текст комментария */
  commentText?: InputMaybe<Scalars['String']['input']>;
  /** Тип для комментария: отзыв/комментарий */
  commentType?: InputMaybe<CommentsTypeTypeEnum>;
  /** массив с id, загруженных файлов */
  filesIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Тип сущности, к котрой будет добавлен комментарий: Товар/Статья/Блог/Рецепт */
  instance: CommentsInstanceTypeEnum;
  /** id сущности */
  objectId: Scalars['Float']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** рейтинг для комментария. На данный момент м.б. указан только для товаров */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** массив с id тегов */
  tags?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type CommentVideoUnion = {
  __typename?: 'CommentVideoUnion';
  converted?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CommentVoteInput = {
  /** Пока только для товара. Тип сущности, по которой будет оценен отзыв: Товар/Статья/Блог/Рецепт */
  object: CommentsVoteInstanceTypeEnum;
  /** Id отзыва */
  objectId?: InputMaybe<Scalars['Float']['input']>;
  /** Полезен ли отзыв */
  useful?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommentsInput = {
  /** текст комментария */
  commentText: Scalars['String']['input'];
  /** Тип для комментария: отзыв/комментарий */
  commentType?: InputMaybe<CommentsTypeTypeEnum>;
  /** массив с id, загруженных файлов */
  filesIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Тип сущности, к котрой будет добавлен комментарий: Товар/Статья/Блог/Рецепт */
  instance: CommentsInstanceTypeEnum;
  /** id сущности */
  objectId: Scalars['Float']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** рейтинг для комментария. На данный момент м.б. указан только для товаров */
  rating?: InputMaybe<Scalars['Float']['input']>;
};

/** Сущность, для которой будет добавлен отзыв/комментарий */
export enum CommentsInstanceTypeEnum {
  Articles = 'Articles',
  Blogchef = 'Blogchef',
  Catalog = 'Catalog',
  News = 'News',
  Recipes = 'Recipes',
  Reviews = 'Reviews'
}

export type CommentsItemInput = {
  /** id комментария */
  commentId?: InputMaybe<Scalars['Int']['input']>;
  /** id опции комментария */
  optionId?: InputMaybe<Scalars['Int']['input']>;
  /** значение поля (если поле селект то значение value игнорируется) */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CommentsItemUnion = {
  __typename?: 'CommentsItemUnion';
  commentItems?: Maybe<Array<Comment>>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CommentsItemsInput = {
  /** данные по каждому коментарию */
  commentsItems?: InputMaybe<Array<CommentsItemInput>>;
};

export type CommentsListOptionsModel = {
  __typename?: 'CommentsListOptionsModel';
  active: Scalars['Int']['output'];
  comment: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type CommentsModel = {
  __typename?: 'CommentsModel';
  active: Scalars['Int']['output'];
  attachment: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  options: Array<CommentsListOptionsModel>;
  placeholder: Scalars['String']['output'];
  required: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CommentsOrderAddressUnion = {
  __typename?: 'CommentsOrderAddressUnion';
  address?: Maybe<CommentsItemUnion>;
  order?: Maybe<CommentsItemUnion>;
};

export type CommentsPhotosUnion = {
  __typename?: 'CommentsPhotosUnion';
  big?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isVideo?: Maybe<Scalars['Boolean']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  video?: Maybe<CommentVideoUnion>;
};

/** Выбрать тип для комментария: отзыв/комментарий */
export enum CommentsTypeTypeEnum {
  Comment = 'Comment',
  Review = 'Review'
}

export type CommentsUnion = {
  __typename?: 'CommentsUnion';
  filePath: Scalars['String']['output'];
};

export type CommentsUnionItemsInput = {
  /** опции комментария для адресса */
  address?: InputMaybe<AddresItem>;
  /** опции комментария для заказа */
  order?: InputMaybe<OrderItem>;
};

export type CommentsUnionModel = {
  __typename?: 'CommentsUnionModel';
  commentsModelItem?: Maybe<CatalogCommentsModel>;
  errors?: Maybe<Array<Errors>>;
  faqItem?: Maybe<FaqModel>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Пока только для товара. */
export enum CommentsVoteInstanceTypeEnum {
  Product = 'PRODUCT'
}

export type CommonReplyUnion = {
  __typename?: 'CommonReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type ConfirmOrderByIdUnion = {
  __typename?: 'ConfirmOrderByIdUnion';
  actionpay?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  /** Комментарии */
  addressCommentsList?: Maybe<CommentsItemUnion>;
  addressItem?: Maybe<PeopleAddressesModel>;
  address_id?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountStoreItem?: Maybe<StoresModel>;
  amount_store_id?: Maybe<Scalars['Int']['output']>;
  availableForRefund: Scalars['Boolean']['output'];
  bill_payed?: Maybe<Scalars['Float']['output']>;
  bill_received?: Maybe<Scalars['Float']['output']>;
  bill_recieve_after_delivery?: Maybe<Scalars['Float']['output']>;
  bill_recieved?: Maybe<Scalars['Float']['output']>;
  cad_id_old?: Maybe<Scalars['Float']['output']>;
  canOrderBeChanged?: Maybe<Scalars['Boolean']['output']>;
  canOrderBeRejected?: Maybe<Scalars['Boolean']['output']>;
  canOrderCommentsBeUpdated?: Maybe<Scalars['Boolean']['output']>;
  cartItem?: Maybe<CartModel>;
  cashback_id?: Maybe<Scalars['String']['output']>;
  cityItem?: Maybe<StoresCityModel>;
  city_id?: Maybe<Scalars['Float']['output']>;
  city_title?: Maybe<Scalars['String']['output']>;
  cln_id_old?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<CatalogCommentsModel>>;
  coords?: Maybe<Scalars['String']['output']>;
  courierItem?: Maybe<CourierModel>;
  courier_id?: Maybe<Scalars['Float']['output']>;
  cur_id?: Maybe<Scalars['Float']['output']>;
  dadataItem?: Maybe<DadataModel>;
  dadata_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryStoreItem?: Maybe<StoresModel>;
  delivery_cost?: Maybe<Scalars['Float']['output']>;
  delivery_date?: Maybe<Scalars['DateTimeISO']['output']>;
  delivery_id?: Maybe<Scalars['Float']['output']>;
  delivery_store_id?: Maybe<Scalars['Int']['output']>;
  delivery_title?: Maybe<Scalars['String']['output']>;
  digital?: Maybe<Scalars['Int']['output']>;
  digitalPromocodes?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<OrdersFieldModel>>;
  fio?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  fromPeopleEmail?: Maybe<Scalars['String']['output']>;
  fromPeopleFio?: Maybe<Scalars['String']['output']>;
  fromPeoplePhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inet_id_old?: Maybe<Scalars['Float']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  interval_id?: Maybe<Scalars['Float']['output']>;
  interval_title?: Maybe<Scalars['String']['output']>;
  /** @deprecated use secretKey */
  key?: Maybe<Scalars['String']['output']>;
  managerItem?: Maybe<OrdersManagersModel>;
  manager_comment?: Maybe<Scalars['String']['output']>;
  manager_id?: Maybe<Scalars['Int']['output']>;
  mng_id?: Maybe<Scalars['Float']['output']>;
  need_receipt?: Maybe<Scalars['Float']['output']>;
  one_click?: Maybe<Scalars['String']['output']>;
  opr_id?: Maybe<Scalars['Float']['output']>;
  ordBeg?: Maybe<Scalars['String']['output']>;
  ordEnd?: Maybe<Scalars['String']['output']>;
  ord_attr?: Maybe<Scalars['String']['output']>;
  ord_beg?: Maybe<Scalars['DateTimeISO']['output']>;
  ord_bns?: Maybe<Scalars['Float']['output']>;
  ord_bnsmns_old?: Maybe<Scalars['Float']['output']>;
  ord_bnspls_old?: Maybe<Scalars['Float']['output']>;
  ord_calcweight?: Maybe<Scalars['Float']['output']>;
  ord_date_old?: Maybe<Scalars['DateTimeISO']['output']>;
  ord_descr?: Maybe<Scalars['String']['output']>;
  ord_dscnt_old?: Maybe<Scalars['Float']['output']>;
  ord_end?: Maybe<Scalars['DateTimeISO']['output']>;
  ord_mark?: Maybe<Scalars['String']['output']>;
  ord_new?: Maybe<Scalars['String']['output']>;
  ord_pay?: Maybe<Scalars['Float']['output']>;
  ord_ship_old?: Maybe<Scalars['Float']['output']>;
  ord_state_old?: Maybe<Scalars['String']['output']>;
  ord_sum?: Maybe<Scalars['Float']['output']>;
  ord_weight?: Maybe<Scalars['Float']['output']>;
  ord_when_old?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Комментарии */
  orderCommentsList?: Maybe<CommentsItemUnion>;
  /** стоимость пакетов */
  orderContainerPrice?: Maybe<Scalars['Float']['output']>;
  orderLoyaltyItems: Array<OrderLoyaltyProgramModel>;
  ordersItems: Array<OrdersItemsModel>;
  paid?: Maybe<Scalars['String']['output']>;
  paid_date?: Maybe<Scalars['DateTimeISO']['output']>;
  paid_total?: Maybe<Scalars['Float']['output']>;
  paid_txn?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  paymentItem?: Maybe<OrdersPaymentsModel>;
  payment_id?: Maybe<Scalars['Int']['output']>;
  payment_title?: Maybe<Scalars['String']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  peopleToken?: Maybe<Scalars['String']['output']>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  positionsAmount?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  promocodeItem?: Maybe<PromocodesModel>;
  promocode_id?: Maybe<Scalars['Float']['output']>;
  promocodesItems?: Maybe<Array<PromocodesModel>>;
  recipeUrl?: Maybe<Scalars['String']['output']>;
  region_city_id?: Maybe<Scalars['Float']['output']>;
  rgn_id?: Maybe<Scalars['Float']['output']>;
  /** Маршрутные листы */
  routesheetItem?: Maybe<OrdersRoutesheetModel>;
  secretKey?: Maybe<Scalars['String']['output']>;
  /** Услуги */
  servicesItems?: Maybe<Array<OrdersServicesModel>>;
  sk_num?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  statusItem?: Maybe<OrdersStatusesModel>;
  status_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  /** Номер стола для барного заказа */
  table?: Maybe<Scalars['Int']['output']>;
  testDriveItem: OrdersTestDrivesModel;
  /** Сумма заказа с учетом стоимости услуг, но без стоимости доставки, промокодов, баллов */
  totalOrderItemsPrice: Scalars['Float']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  us_id?: Maybe<Scalars['Float']['output']>;
  us_saver?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  war_descr?: Maybe<Scalars['String']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type CourierModel = {
  __typename?: 'CourierModel';
  cur_car?: Maybe<Scalars['String']['output']>;
  cur_cargo?: Maybe<Scalars['Float']['output']>;
  cur_count?: Maybe<Scalars['Float']['output']>;
  cur_del?: Maybe<Scalars['String']['output']>;
  cur_fixpay?: Maybe<Scalars['Float']['output']>;
  cur_fuel?: Maybe<Scalars['Float']['output']>;
  cur_id: Scalars['ID']['output'];
  cur_len?: Maybe<Scalars['Float']['output']>;
  cur_name?: Maybe<Scalars['String']['output']>;
  cur_ordcnt?: Maybe<Scalars['Float']['output']>;
  cur_ordpay?: Maybe<Scalars['Float']['output']>;
  cur_phone?: Maybe<Scalars['String']['output']>;
  cur_psp?: Maybe<Scalars['String']['output']>;
  cur_sms?: Maybe<Scalars['String']['output']>;
  cur_speed?: Maybe<Scalars['Float']['output']>;
  cur_staff?: Maybe<Scalars['String']['output']>;
  cur_used?: Maybe<Scalars['String']['output']>;
  cur_wave?: Maybe<Scalars['Float']['output']>;
  cur_workbeg?: Maybe<Scalars['DateTimeISO']['output']>;
  cur_zone?: Maybe<Scalars['String']['output']>;
  dadata_id?: Maybe<Scalars['Float']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  is_virtual: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  medknItem?: Maybe<AttachmentsModel>;
  medkn_id?: Maybe<Scalars['Int']['output']>;
};

export type CrashModel = {
  __typename?: 'CrashModel';
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  info?: Maybe<Scalars['String']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Float']['output']>;
};

export enum CronTaskLocationEnum {
  Cart = 'Cart',
  Catalog = 'Catalog'
}

export type CronTaskStatusGql = {
  __typename?: 'CronTaskStatusGql';
  created_at?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  is_running: Scalars['Boolean']['output'];
  last_run_at?: Maybe<Scalars['DateTimeISO']['output']>;
  location?: Maybe<CronTaskLocationEnum>;
  name: Scalars['String']['output'];
  next_run?: Maybe<Scalars['DateTimeISO']['output']>;
  next_run_at?: Maybe<Scalars['DateTimeISO']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CronTaskUpdateInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CurrentUserCharityUnion = {
  __typename?: 'CurrentUserCharityUnion';
  bill?: Maybe<Scalars['Int']['output']>;
  donated?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CustomRecipesUnion = {
  __typename?: 'CustomRecipesUnion';
  recipeItems?: Maybe<Array<RecipesModel>>;
};

export type DadataInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  area_fias_id?: InputMaybe<Scalars['String']['input']>;
  area_kladr_id?: InputMaybe<Scalars['String']['input']>;
  area_type?: InputMaybe<Scalars['String']['input']>;
  area_type_full?: InputMaybe<Scalars['String']['input']>;
  area_with_type?: InputMaybe<Scalars['String']['input']>;
  beltway_distance?: InputMaybe<Scalars['String']['input']>;
  beltway_hit?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['String']['input']>;
  block_type?: InputMaybe<Scalars['String']['input']>;
  block_type_full?: InputMaybe<Scalars['String']['input']>;
  capital_marker?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_area?: InputMaybe<Scalars['String']['input']>;
  city_district?: InputMaybe<Scalars['String']['input']>;
  city_district_fias_id?: InputMaybe<Scalars['String']['input']>;
  city_district_kladr_id?: InputMaybe<Scalars['String']['input']>;
  city_district_type?: InputMaybe<Scalars['String']['input']>;
  city_district_type_full?: InputMaybe<Scalars['String']['input']>;
  city_district_with_type?: InputMaybe<Scalars['String']['input']>;
  city_fias_id?: InputMaybe<Scalars['String']['input']>;
  city_kladr_id?: InputMaybe<Scalars['String']['input']>;
  city_type?: InputMaybe<Scalars['String']['input']>;
  city_type_full?: InputMaybe<Scalars['String']['input']>;
  city_with_type?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_iso_code?: InputMaybe<Scalars['String']['input']>;
  federal_district?: InputMaybe<Scalars['String']['input']>;
  fias_actuality_state?: InputMaybe<Scalars['String']['input']>;
  fias_code?: InputMaybe<Scalars['String']['input']>;
  fias_id?: InputMaybe<Scalars['String']['input']>;
  fias_level?: InputMaybe<Scalars['String']['input']>;
  flat?: InputMaybe<Scalars['String']['input']>;
  flat_area?: InputMaybe<Scalars['String']['input']>;
  flat_price?: InputMaybe<Scalars['String']['input']>;
  flat_type?: InputMaybe<Scalars['String']['input']>;
  flat_type_full?: InputMaybe<Scalars['String']['input']>;
  geo_lat?: InputMaybe<Scalars['String']['input']>;
  geo_lon?: InputMaybe<Scalars['String']['input']>;
  geoname_id?: InputMaybe<Scalars['String']['input']>;
  history_values?: InputMaybe<Array<Scalars['String']['input']>>;
  house?: InputMaybe<Scalars['String']['input']>;
  house_fias_id?: InputMaybe<Scalars['String']['input']>;
  house_kladr_id?: InputMaybe<Scalars['String']['input']>;
  house_type?: InputMaybe<Scalars['String']['input']>;
  house_type_full?: InputMaybe<Scalars['String']['input']>;
  kladr_id?: InputMaybe<Scalars['String']['input']>;
  metro?: InputMaybe<Scalars['String']['input']>;
  okato?: InputMaybe<Scalars['String']['input']>;
  oktmo?: InputMaybe<Scalars['String']['input']>;
  postal_box?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  qc?: InputMaybe<Scalars['String']['input']>;
  qc_complete?: InputMaybe<Scalars['String']['input']>;
  qc_geo?: InputMaybe<Scalars['String']['input']>;
  qc_house?: InputMaybe<Scalars['String']['input']>;
  raw_json?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  region_fias_id?: InputMaybe<Scalars['String']['input']>;
  region_iso_code?: InputMaybe<Scalars['String']['input']>;
  region_kladr_id?: InputMaybe<Scalars['String']['input']>;
  region_type?: InputMaybe<Scalars['String']['input']>;
  region_type_full?: InputMaybe<Scalars['String']['input']>;
  region_with_type?: InputMaybe<Scalars['String']['input']>;
  settlement?: InputMaybe<Scalars['String']['input']>;
  settlement_fias_id?: InputMaybe<Scalars['String']['input']>;
  settlement_kladr_id?: InputMaybe<Scalars['String']['input']>;
  settlement_type?: InputMaybe<Scalars['String']['input']>;
  settlement_type_full?: InputMaybe<Scalars['String']['input']>;
  settlement_with_type?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  square_meter_price?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_fias_id?: InputMaybe<Scalars['String']['input']>;
  street_kladr_id?: InputMaybe<Scalars['String']['input']>;
  street_type?: InputMaybe<Scalars['String']['input']>;
  street_type_full?: InputMaybe<Scalars['String']['input']>;
  street_with_type?: InputMaybe<Scalars['String']['input']>;
  tax_office?: InputMaybe<Scalars['String']['input']>;
  tax_office_legal?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  unparsed_parts?: InputMaybe<Scalars['String']['input']>;
};

export type DadataModel = {
  __typename?: 'DadataModel';
  area?: Maybe<Scalars['String']['output']>;
  area_fias_id?: Maybe<Scalars['String']['output']>;
  area_kladr_id?: Maybe<Scalars['String']['output']>;
  area_type?: Maybe<Scalars['String']['output']>;
  beltway_distance?: Maybe<Scalars['Float']['output']>;
  beltway_hit?: Maybe<Scalars['Float']['output']>;
  block?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  block_type?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityType?: Maybe<Scalars['String']['output']>;
  city_area?: Maybe<Scalars['String']['output']>;
  city_district?: Maybe<Scalars['String']['output']>;
  city_district_fias_id?: Maybe<Scalars['String']['output']>;
  city_district_type?: Maybe<Scalars['String']['output']>;
  city_fias_id?: Maybe<Scalars['String']['output']>;
  city_kladr_id?: Maybe<Scalars['String']['output']>;
  city_type?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  fias_id?: Maybe<Scalars['String']['output']>;
  fias_level?: Maybe<Scalars['Float']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  geoLat?: Maybe<Scalars['Float']['output']>;
  geoLon?: Maybe<Scalars['Float']['output']>;
  geo_lat?: Maybe<Scalars['Float']['output']>;
  geo_lon?: Maybe<Scalars['Float']['output']>;
  house?: Maybe<Scalars['String']['output']>;
  houseType?: Maybe<Scalars['String']['output']>;
  house_fias_id?: Maybe<Scalars['String']['output']>;
  house_kladr_id?: Maybe<Scalars['String']['output']>;
  house_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_cleaned?: Maybe<Scalars['Float']['output']>;
  is_fixed?: Maybe<Scalars['Float']['output']>;
  kladr_id?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTimeISO']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  qc?: Maybe<Scalars['Float']['output']>;
  qc_geo?: Maybe<Scalars['Float']['output']>;
  raw_json?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  region_fias_id?: Maybe<Scalars['String']['output']>;
  region_kladr_id?: Maybe<Scalars['String']['output']>;
  region_type?: Maybe<Scalars['String']['output']>;
  settlement?: Maybe<Scalars['String']['output']>;
  settlementType?: Maybe<Scalars['String']['output']>;
  settlement_fias_id?: Maybe<Scalars['String']['output']>;
  settlement_kladr_id?: Maybe<Scalars['String']['output']>;
  settlement_type?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetType?: Maybe<Scalars['String']['output']>;
  street_fias_id?: Maybe<Scalars['String']['output']>;
  street_kladr_id?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

export type DadataUnion = {
  __typename?: 'DadataUnion';
  dadataItem?: Maybe<DadataModel>;
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DataPeopleCharityUnion = {
  __typename?: 'DataPeopleCharityUnion';
  charityParticipantsMore?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUserCharityUnion>;
  participants?: Maybe<Array<ParticipantsCharityUnion>>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
  totalPeople?: Maybe<Scalars['Int']['output']>;
};

export type DataUnion = {
  __typename?: 'DataUnion';
  /** количество */
  amount?: Maybe<Scalars['Float']['output']>;
  /** банки */
  banks?: Maybe<Array<BanksUnion>>;
  /** сслыка на сбп оплату */
  link?: Maybe<Scalars['String']['output']>;
  /** способ оплаты */
  payment_id?: Maybe<Scalars['Float']['output']>;
};

export type DeliveryCloseInfoReplyUnion = {
  __typename?: 'DeliveryCloseInfoReplyUnion';
  /** ближайшая дата доставки */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** id интревала доставки */
  deliveryRangeId?: Maybe<Scalars['Float']['output']>;
  /** временной отрезок */
  deliveryTitle?: Maybe<Scalars['String']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** кол-во минут между сегодня и ближайшим днем доставки БЕЗ учета планового отключения */
  minBeforeDeliveryClosed?: Maybe<Scalars['Float']['output']>;
  /** кол-во минут между сегодня и ближайшим днем доставки С учетом планового отключения */
  minBeforeDeliveryClosedWithBlock?: Maybe<Scalars['Float']['output']>;
  /** детали запроса */
  sendData?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export enum EmailTypes {
  BlockEnter = 'block_enter',
  BlockUser = 'block_user',
  Callback = 'callback',
  Catering = 'catering',
  CompanyClaim = 'company_claim',
  Contacts = 'contacts',
  Courier = 'courier',
  Faq = 'faq',
  InStock = 'in_stock',
  NewComment = 'new_comment',
  OfferToMakeFirstOrder = 'offer_to_make_first_order',
  PasswordRecovery = 'password_recovery',
  PriceDrop = 'price_drop',
  Promocode = 'promocode',
  SeoPages = 'seo_pages',
  StoreReview = 'store_review',
  Subscribe = 'subscribe',
  TableBooking = 'table_booking'
}

export type Errors = {
  __typename?: 'Errors';
  error?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EstinateReviewReplyUnion = {
  __typename?: 'EstinateReviewReplyUnion';
  commentItem?: Maybe<CatalogCommentsModel>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  reviewItem?: Maybe<ReviewsModel>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type FaqMessagesModel = {
  __typename?: 'FaqMessagesModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  faqItem?: Maybe<FaqModel>;
  faq_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  userItem?: Maybe<UsersModel>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type FaqModel = {
  __typename?: 'FaqModel';
  active?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerUserItem?: Maybe<UsersModel>;
  answer_date?: Maybe<Scalars['DateTimeISO']['output']>;
  answer_user_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faqMessagesItems?: Maybe<Array<FaqMessagesModel>>;
  id: Scalars['ID']['output'];
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type FaqUnion = {
  __typename?: 'FaqUnion';
  faqItems?: Maybe<Array<FaqModel>>;
  totalCount: Scalars['Int']['output'];
  totalCountMe: Scalars['Int']['output'];
};

export type FavoritesModel = {
  __typename?: 'FavoritesModel';
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  is_postponed?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  recipeItem?: Maybe<RecipesModel>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
};

export type FavoritesUnion = {
  __typename?: 'FavoritesUnion';
  error?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  item?: Maybe<FavoritesModel>;
  result?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetFileInput = {
  /** фильтр. варианты: 'w10' - картинка с шириной 10px; 'h20' -высота 20; 'w30h25' -ширина 30, высота 25; 'd25' - 25*25 */
  filter: Scalars['String']['input'];
  /** Тип сущности, для которой будет создан файл: Товар/Статья/Блог/Рецепт */
  instance: GetFileInstancesTypeEnum;
  /** id сущности */
  objectId: Scalars['Float']['input'];
};

/** Сущность, для которой будет созад файл */
export enum GetFileInstancesTypeEnum {
  Articles = 'Articles',
  Banner = 'Banner',
  Blogchef = 'Blogchef',
  Category = 'Category',
  News = 'News',
  People = 'People',
  Product = 'Product',
  Recipes = 'Recipes',
  TestDrive = 'TestDrive'
}

export type GetPeopleCommentStats = {
  __typename?: 'GetPeopleCommentStats';
  title?: Maybe<Array<Scalars['String']['output']>>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CatalogTypesModel>;
};

export type GetPostCardReplyUnion = {
  __typename?: 'GetPostCardReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** открытки к цветам */
  postcards?: Maybe<Array<PostCardUnion>>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type IosUnion = {
  __typename?: 'IOSUnion';
  /** ссылка */
  link?: Maybe<Scalars['String']['output']>;
  /** схема */
  scheme?: Maybe<Scalars['String']['output']>;
};

export type IndexAdditionUnion = {
  __typename?: 'IndexAdditionUnion';
  interestProducts?: Maybe<Array<CatalogModel>>;
  /** Сушность, с установленным профилем пользователя на данный момент */
  peopleProfile?: Maybe<PeopleProfileModel>;
  recommendProducts?: Maybe<Array<CatalogModel>>;
};

export type IndexCoreUnion = {
  __typename?: 'IndexCoreUnion';
  banners?: Maybe<Array<BannersModel>>;
  newbeeProducts?: Maybe<Array<CatalogModel>>;
  /** Сушность, с установленным профилем пользователя на данный момент */
  peopleProfile?: Maybe<PeopleProfileModel>;
  pofdProducts?: Maybe<Array<CatalogModel>>;
  /** Время окончания акции */
  pofdProductsDateEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Серверное время */
  pofdProductssTime?: Maybe<Scalars['DateTimeISO']['output']>;
  popularProducts?: Maybe<Array<CatalogModel>>;
  recipes?: Maybe<Array<RecipesModel>>;
};

export type IndexReviewsUnion = {
  __typename?: 'IndexReviewsUnion';
  reviews?: Maybe<Array<ReviewsModel>>;
};

export type IndexUnion = {
  __typename?: 'IndexUnion';
  banners?: Maybe<Array<BannersModel>>;
  interestProducts?: Maybe<Array<CatalogModel>>;
  newbeeProducts?: Maybe<Array<CatalogModel>>;
  pofdProducts?: Maybe<Array<CatalogModel>>;
  popularProducts?: Maybe<Array<CatalogModel>>;
  recipes?: Maybe<Array<RecipesModel>>;
  recommendProducts?: Maybe<Array<CatalogModel>>;
  reviews?: Maybe<Array<ReviewsModel>>;
};

export type LinkForAccessCodeReplyUnion = {
  __typename?: 'LinkForAccessCodeReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Получение ссылки на вход через сбербанк */
  link?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyProgramModel = {
  __typename?: 'LoyaltyProgramModel';
  bonusPercentage?: Maybe<Scalars['Int']['output']>;
  bonus_percentage?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTimeISO']['output']>;
  freeDelivery?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Float']['output']>;
  is_free_delivery?: Maybe<Scalars['Float']['output']>;
  maxQuantityInOrder?: Maybe<Scalars['Int']['output']>;
  max_quantity_in_order?: Maybe<Scalars['Float']['output']>;
  minOrderPrice?: Maybe<Scalars['Int']['output']>;
  modified_at?: Maybe<Scalars['DateTimeISO']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  people_status_id?: Maybe<Scalars['Int']['output']>;
  previous_order_price?: Maybe<Scalars['Float']['output']>;
  productsAsGifts?: Maybe<Array<CatalogModel>>;
  servicesAsGifts?: Maybe<Array<ServicesModel>>;
  statusItem?: Maybe<PeopleStatusModel>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Тип макронутриентов */
export enum Macronutrients {
  Carbs = 'carbs',
  Fats = 'fats',
  Proteins = 'proteins'
}

export type MaxLoginStartReply = {
  __typename?: 'MaxLoginStartReply';
  /** код входа, с ним потом опрашивать статус */
  code?: Maybe<Scalars['String']['output']>;
  /** сообщение об ошибке */
  error?: Maybe<Scalars['String']['output']>;
  /** ссылка на бота MAX */
  link?: Maybe<Scalars['String']['output']>;
  /** результат выполнения операции */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** сколько секунд живёт код */
  ttl?: Maybe<Scalars['Int']['output']>;
};

export type MenuTypesModel = {
  __typename?: 'MenuTypesModel';
  active?: Maybe<Scalars['Int']['output']>;
  available_from?: Maybe<Scalars['String']['output']>;
  available_to?: Maybe<Scalars['DateTimeISO']['output']>;
  catalogTypes?: Maybe<Array<CatalogTypesModel>>;
  file_url?: Maybe<Scalars['String']['output']>;
  icon_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  store_ids?: Maybe<Scalars['String']['output']>;
  week_days?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type MetroLinesModel = {
  __typename?: 'MetroLinesModel';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type MetroStationsModel = {
  __typename?: 'MetroStationsModel';
  id: Scalars['Int']['output'];
  line: MetroLinesModel;
  line_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  GRSubAction: ReplyUnion;
  actionFavoriteItem: FavoritesUnion;
  addCartComment: Scalars['Boolean']['output'];
  addComment: CommentsUnionModel;
  addCommentsToAdress: Scalars['Boolean']['output'];
  addCommentsToOrder: Scalars['Boolean']['output'];
  addCommentsToOrderOrAddress: Scalars['Boolean']['output'];
  addDefaultComment: Scalars['Boolean']['output'];
  addFaqItem: CommentsUnionModel;
  addPostcard: AddPostCardReplyUnion;
  addProductAfterPurchase: OrderReplyUnion;
  addProfilePicture: UploadUnion;
  addProfilePicture2: UploadUnion;
  addRecipeToFavoritesList: FavoritesUnion;
  addRecipesItem: RecipesModel;
  addReview: ReviewsModel;
  addSlideToHistory: Scalars['Boolean']['output'];
  addSubscriberTemp: ReplyUnion;
  addTaskToProgress: TasksReplyUnion;
  addTipsForCourier: Scalars['Boolean']['output'];
  adminLoginManually?: Maybe<Scalars['Boolean']['output']>;
  applyForRefund: OrderRefundItemModel;
  applyPromocodeForCart?: Maybe<ApplyPromocodeReplyUnion>;
  calculateDeliveryIntervalsStats: Scalars['String']['output'];
  catalogAmountUpdate: CommonReplyUnion;
  changeEmailBySms: PeopleReplyUnion;
  charity?: Maybe<PeopleCharityUnion>;
  checkGRSub: Scalars['Boolean']['output'];
  cleanupCronTaskLogs: Scalars['String']['output'];
  clearCatalogSubs: CommonReplyUnion;
  copyProfilePicture: Scalars['String']['output'];
  countTestedTestDrives: Scalars['String']['output'];
  createFeedStore: Scalars['String']['output'];
  createPayLink: Scalars['String']['output'];
  createSearchBoosterStatisticsFile: Scalars['String']['output'];
  cronRunTask: CommonReplyUnion;
  cronStartTask: CommonReplyUnion;
  cronStopTask: CommonReplyUnion;
  cronUpdateTask: CommonReplyUnion;
  deletePeople?: Maybe<CommonReplyUnion>;
  deletePeopleSearchQuery?: Maybe<Scalars['Boolean']['output']>;
  /** удаление подписки у пользователя */
  deleteSubscribtion: ReplyUnion;
  editPeopleReviewById?: Maybe<CabitetEditReviewReplyUnion>;
  forgotPassword: Scalars['String']['output'];
  generateSitemap: Scalars['String']['output'];
  /** получение картинки по фильтру */
  getImg: Scalars['String']['output'];
  /** получение картинки по фильтру */
  getImg2: Scalars['String']['output'];
  login?: Maybe<PeopleModel>;
  loginByPhoneAnyWay: PeopleReplyUnion;
  loginManually?: Maybe<PeopleModel>;
  loginOrRegisterByEmail: PeopleReplyUnion;
  loginOrRegisterBySms: PeopleReplyUnion;
  logout: Scalars['Boolean']['output'];
  maxLoginCheck: PeopleReplyUnion;
  maxLoginStart: MaxLoginStartReply;
  notifyInStockAgainSubscribers: Scalars['String']['output'];
  notifyPriceDropSubscribers: Scalars['String']['output'];
  offerToMakeFirstOrder: Scalars['String']['output'];
  oneSignalHistorySpamSave?: Maybe<Scalars['String']['output']>;
  /** @deprecated метод заменен методом oneSignalSpamToogle данный удалить как на фронте удалят */
  oneSignalSpamCancel: ReplyUnion;
  oneSignalSpamToogle: ReplyUnion;
  partnerLoginOrRegister: PeopleReplyUnion;
  productSubscribe: ReplyUnion;
  rateAnswer: EstinateReviewReplyUnion;
  rebindCartPid: CommonReplyUnion;
  recountRating: CommonReplyUnion;
  recountSalesNumber: CommonReplyUnion;
  recountTestDrvies: Scalars['String']['output'];
  register: PeopleModel;
  removeRecipeFromFavoritesList: FavoritesUnion;
  saveCartTemplateItem?: Maybe<CabinetUnion>;
  savePeopleProfile?: Maybe<Scalars['Boolean']['output']>;
  savePeopleSettings: Scalars['Boolean']['output'];
  sberIdAction: SocialActionReplyUnion;
  sendSeoPagesUpdatedEmail: Scalars['String']['output'];
  setCookie: Scalars['Boolean']['output'];
  setCrash: CrashModel;
  setImageType: AttachmentsRelationsModel;
  setOffAutoFixedComments: Scalars['String']['output'];
  setOrderField: Scalars['Boolean']['output'];
  setOrderPaymentType?: Maybe<SetOrderPaymentTypeUnion>;
  setPeopleAvatar?: Maybe<PeopleModel>;
  setTestDriveCompletedAndAmountFields: Scalars['String']['output'];
  setTestDrivesCompletedField: Scalars['String']['output'];
  socialAction?: Maybe<SocialActionReplyUnion>;
  /** управление смс подпиской */
  subscribeSMS: ReplyUnion;
  updateCartItems?: Maybe<Scalars['String']['output']>;
  updateCatalogSubs: CatalogSubscribersModel;
  updateCatalogTypesStats: Scalars['String']['output'];
  updateOneSignalActiveUsers?: Maybe<Scalars['String']['output']>;
  updateSalesNumber: Scalars['String']['output'];
  voteForArticle: ArticlesModel;
  voteForComment: CatalogCommentsModel;
  voteForRecipe: RecipesModel;
  voteForReview: ReviewsModel;
};


export type MutationGrSubActionArgs = {
  action?: SubscribtionAction;
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationActionFavoriteItemArgs = {
  action?: Scalars['String']['input'];
  object: Scalars['String']['input'];
  objectId: Scalars['Int']['input'];
  postponed?: Scalars['Boolean']['input'];
};


export type MutationAddCartCommentArgs = {
  cartToken: Scalars['String']['input'];
  comment: CommentsItemsInput;
};


export type MutationAddCommentArgs = {
  data: CommentsInput;
};


export type MutationAddCommentsToAdressArgs = {
  comment: CommentsItemsInput;
  id: Scalars['Int']['input'];
};


export type MutationAddCommentsToOrderArgs = {
  comment: CommentsItemsInput;
  id: Scalars['Int']['input'];
};


export type MutationAddCommentsToOrderOrAddressArgs = {
  data: CommentsUnionItemsInput;
};


export type MutationAddDefaultCommentArgs = {
  comment: CommentsItemsInput;
};


export type MutationAddFaqItemArgs = {
  email: Scalars['String']['input'];
  peopleId: Scalars['Int']['input'];
  question: Scalars['String']['input'];
};


export type MutationAddPostcardArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  data: PostcardInput;
};


export type MutationAddProductAfterPurchaseArgs = {
  orderId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  quantity?: Scalars['Int']['input'];
};


export type MutationAddProfilePictureArgs = {
  key: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddProfilePicture2Args = {
  key: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddRecipeToFavoritesListArgs = {
  data: ReciepeToFavoritesInput;
};


export type MutationAddRecipesItemArgs = {
  data: RecipesInput;
  people_id: Scalars['Int']['input'];
  recipeIngredients: Array<RecipesIngredientsInput>;
  recipeInstructions: Array<RecipesInstructionInput>;
};


export type MutationAddReviewArgs = {
  data: ReviewInput;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddSlideToHistoryArgs = {
  slideId: Scalars['Int']['input'];
};


export type MutationAddSubscriberTempArgs = {
  source?: Scalars['String']['input'];
  subscribeEmail: Scalars['String']['input'];
  subscribe_type?: Scalars['String']['input'];
};


export type MutationAddTaskToProgressArgs = {
  taskId: Scalars['Int']['input'];
};


export type MutationAddTipsForCourierArgs = {
  bonuses: Scalars['Int']['input'];
  courierId: Scalars['Int']['input'];
};


export type MutationAdminLoginManuallyArgs = {
  key: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationApplyForRefundArgs = {
  amount?: Scalars['Int']['input'];
  catalogId: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  commentIds?: Array<Scalars['Int']['input']>;
  containerIds?: Array<Scalars['Int']['input']>;
  fileIds?: Array<Scalars['Int']['input']>;
  orderItemId?: InputMaybe<Scalars['Int']['input']>;
  paymentTypeId: Scalars['Int']['input'];
};


export type MutationApplyPromocodeForCartArgs = {
  cartToken: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCatalogAmountUpdateArgs = {
  limit?: Scalars['Int']['input'];
};


export type MutationChangeEmailBySmsArgs = {
  action?: PeopleSmsAction;
  code?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationCharityArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  data: PeopleCharityInput;
};


export type MutationClearCatalogSubsArgs = {
  type: CatalogSubE;
};


export type MutationCopyProfilePictureArgs = {
  filedata?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  tempFileName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCountTestedTestDrivesArgs = {
  testDrivesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationCreatePayLinkArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCronRunTaskArgs = {
  taskId: Scalars['Int']['input'];
};


export type MutationCronStartTaskArgs = {
  taskId: Scalars['Int']['input'];
};


export type MutationCronStopTaskArgs = {
  taskId: Scalars['Int']['input'];
};


export type MutationCronUpdateTaskArgs = {
  input: CronTaskUpdateInput;
  taskId: Scalars['Int']['input'];
};


export type MutationDeletePeopleSearchQueryArgs = {
  queryId: Scalars['Float']['input'];
};


export type MutationEditPeopleReviewByIdArgs = {
  data: CommentOrReviewInput;
  toDelete?: Scalars['Boolean']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateSitemapArgs = {
  token: Scalars['String']['input'];
};


export type MutationGetImgArgs = {
  data: GetFileInput;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetImg2Args = {
  data: GetFileInput;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  webPushToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginByPhoneAnyWayArgs = {
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['Int']['input']>;
  webPushToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginManuallyArgs = {
  id: Scalars['Float']['input'];
  key: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationLoginOrRegisterByEmailArgs = {
  action?: PeopleSmsAction;
  data: RegisterInput;
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  webPushToken?: InputMaybe<Scalars['String']['input']>;
  withoutActivation?: Scalars['Boolean']['input'];
};


export type MutationLoginOrRegisterBySmsArgs = {
  action?: PeopleSmsAction;
  code?: InputMaybe<Scalars['Int']['input']>;
  courierId?: InputMaybe<Scalars['Int']['input']>;
  isMenu?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  webPushToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMaxLoginCheckArgs = {
  code: Scalars['String']['input'];
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  webPushToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOneSignalSpamToogleArgs = {
  setSpamTo: Scalars['Boolean']['input'];
};


export type MutationPartnerLoginOrRegisterArgs = {
  code: Scalars['String']['input'];
  forMenu?: Scalars['Boolean']['input'];
  isMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  session_state: Scalars['String']['input'];
  state: Scalars['String']['input'];
  webPushToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductSubscribeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Float']['input'];
  subscription_type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRateAnswerArgs = {
  rating?: Scalars['Float']['input'];
  reviewId: Scalars['Float']['input'];
  storeOrProductCommentType?: StoreOrProductCommentsTypeEnum;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRebindCartPidArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  peopleToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecountTestDrviesArgs = {
  testDrivesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationRegisterArgs = {
  data: RegisterInput;
  withoutActivation?: Scalars['Boolean']['input'];
};


export type MutationRemoveRecipeFromFavoritesListArgs = {
  data: ReciepeToFavoritesInput;
};


export type MutationSaveCartTemplateItemArgs = {
  cartToken: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSavePeopleProfileArgs = {
  data: PeopleInput;
};


export type MutationSavePeopleSettingsArgs = {
  bonusSettings?: InputMaybe<BonusesInput>;
  cabinetSettings: SettingsInput;
  cartSettings?: InputMaybe<CardInput>;
  peopleSubscribs: SubscribesInput;
  smsSettings?: InputMaybe<SmsInput>;
};


export type MutationSberIdActionArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationSetCookieArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetCrashArgs = {
  error: Scalars['String']['input'];
  info: Scalars['String']['input'];
};


export type MutationSetImageTypeArgs = {
  fileId: Scalars['Float']['input'];
  typeId: Scalars['Float']['input'];
};


export type MutationSetOrderFieldArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationSetOrderPaymentTypeArgs = {
  orderId: Scalars['Int']['input'];
  paymentId: Scalars['Int']['input'];
};


export type MutationSetPeopleAvatarArgs = {
  data: AvatarInput;
};


export type MutationSetTestDriveCompletedAndAmountFieldsArgs = {
  testDriveIds: Array<Scalars['Int']['input']>;
};


export type MutationSocialActionArgs = {
  data: SocialDataInput;
  method: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationSubscribeSmsArgs = {
  action: Scalars['Boolean']['input'];
};


export type MutationUpdateCartItemsArgs = {
  amount?: Scalars['Float']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateCatalogSubsArgs = {
  catalogId: Scalars['Int']['input'];
  email: Scalars['Boolean']['input'];
  phone: Scalars['Boolean']['input'];
  type: CatalogSubE;
};


export type MutationUpdateSalesNumberArgs = {
  catalogId: Scalars['Float']['input'];
};


export type MutationVoteForArticleArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  data: VoteForArticleInput;
};


export type MutationVoteForCommentArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  data: CommentVoteInput;
};


export type MutationVoteForRecipeArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  data: VoteForRecipeInput;
};


export type MutationVoteForReviewArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  data: ReviewVoteInput;
};

export type NewsCommentsModel = {
  __typename?: 'NewsCommentsModel';
  active?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerUserItem?: Maybe<UsersModel>;
  answer_date?: Maybe<Scalars['DateTimeISO']['output']>;
  answer_user_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  newsItem?: Maybe<NewsModel>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NewsModel = {
  __typename?: 'NewsModel';
  active?: Maybe<Scalars['String']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  commentsItem?: Maybe<Array<NewsCommentsModel>>;
  concat_exmpl: Scalars['String']['output'];
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  icon_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  is_charity?: Maybe<Scalars['Float']['output']>;
  is_fixed?: Maybe<Scalars['Float']['output']>;
  is_participants_visible?: Maybe<Scalars['Float']['output']>;
  modified_at?: Maybe<Scalars['DateTimeISO']['output']>;
  newsCategory: Scalars['String']['output'];
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  short_title?: Maybe<Scalars['String']['output']>;
  stretch_id?: Maybe<Scalars['Float']['output']>;
  svg_code?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  video_code?: Maybe<Scalars['String']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
  video_title?: Maybe<Scalars['String']['output']>;
};

export type NewsUnion = {
  __typename?: 'NewsUnion';
  commentsItem?: Maybe<Array<NewsCommentsModel>>;
  totalCount: Scalars['Int']['output'];
};

export enum NotificationEventEnum {
  InStock = 'in_stock',
  PriceDrop = 'price_drop'
}

export type OrderCartUnion = {
  __typename?: 'OrderCartUnion';
  cookieId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** Order direction for sorting */
export enum OrderDir {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderHistoryPercentStatsUnion = {
  __typename?: 'OrderHistoryPercentStatsUnion';
  stats?: Maybe<Array<OrderHistoryProductStatsUnion>>;
  totalOrderAmount?: Maybe<Scalars['Float']['output']>;
};

export type OrderHistoryProductStatsUnion = {
  __typename?: 'OrderHistoryProductStatsUnion';
  percent?: Maybe<Scalars['Float']['output']>;
  typeItem?: Maybe<CatalogTypesModel>;
};

export type OrderItem = {
  /** опции комментария для заказа */
  comment?: InputMaybe<Array<CommentsItemInput>>;
  /** id заказа */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderItemsContainersModel = {
  __typename?: 'OrderItemsContainersModel';
  barcode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_amount?: Maybe<Scalars['Int']['output']>;
  item_barcode?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  item_weight?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type OrderItemsRefundContainersModel = {
  __typename?: 'OrderItemsRefundContainersModel';
  containerItem?: Maybe<OrderItemsContainersModel>;
  container_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  refundItem?: Maybe<OrderRefundItemModel>;
  refund_id?: Maybe<Scalars['Int']['output']>;
};

export type OrderItemsReplacementsModel = {
  __typename?: 'OrderItemsReplacementsModel';
  amount?: Maybe<Scalars['Int']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  id?: Maybe<Scalars['Int']['output']>;
  item_before_id?: Maybe<Scalars['Int']['output']>;
  item_order_id?: Maybe<Scalars['Int']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type OrderLoyaltyProgramModel = {
  __typename?: 'OrderLoyaltyProgramModel';
  loyaltyProgramItem?: Maybe<LoyaltyProgramModel>;
  loyalty_program_id?: Maybe<Scalars['Float']['output']>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  productItem?: Maybe<CatalogModel>;
  product_id?: Maybe<Scalars['Int']['output']>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
};

export type OrderPaymentRefundType = {
  __typename?: 'OrderPaymentRefundType';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OrderRefundItemModel = {
  __typename?: 'OrderRefundItemModel';
  active?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  attachmentsItem?: Maybe<Array<AttachmentsModel>>;
  comment?: Maybe<Scalars['String']['output']>;
  commentItems?: Maybe<Array<RefundCommentListModel>>;
  containerItems?: Maybe<Array<OrderItemsRefundContainersModel>>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<OrdersModel>;
  orderItem?: Maybe<OrdersItemsModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  order_item_id?: Maybe<Scalars['Int']['output']>;
  photos?: Maybe<Array<CommentsPhotosUnion>>;
  refund_type_id?: Maybe<Scalars['Int']['output']>;
  relations?: Maybe<Array<RefundRelationsModel>>;
  status_id?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_weight?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<OrderPaymentRefundType>;
};

export type OrderReplyUnion = {
  __typename?: 'OrderReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** заказ */
  orderItem?: Maybe<OrdersModel>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type OrdersCitiesModel = {
  __typename?: 'OrdersCitiesModel';
  active?: Maybe<Scalars['String']['output']>;
  cty_del?: Maybe<Scalars['String']['output']>;
  dadata_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  old_id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OrdersDeliveryModel = {
  __typename?: 'OrdersDeliveryModel';
  active?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  min_price?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
  timeid?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['DateTimeISO']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OrdersFieldModel = {
  __typename?: 'OrdersFieldModel';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OrdersItemsModel = {
  __typename?: 'OrdersItemsModel';
  amount?: Maybe<Scalars['Float']['output']>;
  availableForRefund?: Maybe<Scalars['Boolean']['output']>;
  averPrice?: Maybe<Scalars['Float']['output']>;
  averWeight?: Maybe<Scalars['Float']['output']>;
  barcodes?: Maybe<Scalars['String']['output']>;
  buyButton?: Maybe<Scalars['Float']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  containerItems?: Maybe<Array<OrderItemsContainersModel>>;
  containers?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  gds_id_old?: Maybe<Scalars['Float']['output']>;
  getOrderItemWeightPrice?: Maybe<Scalars['Float']['output']>;
  getTotalOrderItemPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isAlreadyReviewed?: Maybe<Scalars['Boolean']['output']>;
  isCommented?: Maybe<Scalars['Boolean']['output']>;
  isFreeForTestDrive?: Maybe<Scalars['Boolean']['output']>;
  item_amount?: Maybe<Scalars['Float']['output']>;
  item_price?: Maybe<Scalars['Float']['output']>;
  item_weight?: Maybe<Scalars['Float']['output']>;
  kit_id?: Maybe<Scalars['Float']['output']>;
  new_id?: Maybe<Scalars['Float']['output']>;
  ord_bonus?: Maybe<Scalars['Float']['output']>;
  ord_dscnt?: Maybe<Scalars['Float']['output']>;
  ord_id_old?: Maybe<Scalars['Float']['output']>;
  ord_prc?: Maybe<Scalars['Float']['output']>;
  ord_price?: Maybe<Scalars['Float']['output']>;
  ord_qnty?: Maybe<Scalars['Float']['output']>;
  ord_weight?: Maybe<Scalars['Float']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  ordersItem?: Maybe<OrdersModel>;
  prc_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceDiff?: Maybe<Scalars['Float']['output']>;
  refundItem?: Maybe<Array<OrderRefundItemModel>>;
  replacementItems?: Maybe<Array<OrderItemsReplacementsModel>>;
  trf_id?: Maybe<Scalars['Float']['output']>;
  /** Оставлял ли юзер уже отзыв по этой позиции заказа, если да - оценка */
  userReviewRating?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightDiff?: Maybe<Scalars['Float']['output']>;
  weight_total?: Maybe<Scalars['Float']['output']>;
};

export type OrdersManagersModel = {
  __typename?: 'OrdersManagersModel';
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  ug_id?: Maybe<Scalars['Float']['output']>;
  us_del?: Maybe<Scalars['String']['output']>;
  us_id: Scalars['ID']['output'];
  us_login?: Maybe<Scalars['String']['output']>;
  us_name?: Maybe<Scalars['String']['output']>;
  us_password?: Maybe<Scalars['String']['output']>;
  us_sms?: Maybe<Scalars['String']['output']>;
};

export type OrdersModel = {
  __typename?: 'OrdersModel';
  actionpay?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  /** Комментарии */
  addressCommentsList?: Maybe<CommentsItemUnion>;
  addressItem?: Maybe<PeopleAddressesModel>;
  address_id?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountStoreItem?: Maybe<StoresModel>;
  amount_store_id?: Maybe<Scalars['Int']['output']>;
  availableForRefund: Scalars['Boolean']['output'];
  bill_payed?: Maybe<Scalars['Float']['output']>;
  bill_received?: Maybe<Scalars['Float']['output']>;
  bill_recieve_after_delivery?: Maybe<Scalars['Float']['output']>;
  bill_recieved?: Maybe<Scalars['Float']['output']>;
  cad_id_old?: Maybe<Scalars['Float']['output']>;
  canOrderBeChanged?: Maybe<Scalars['Boolean']['output']>;
  canOrderBeRejected?: Maybe<Scalars['Boolean']['output']>;
  canOrderCommentsBeUpdated?: Maybe<Scalars['Boolean']['output']>;
  cartItem?: Maybe<CartModel>;
  cashback_id?: Maybe<Scalars['String']['output']>;
  cityItem?: Maybe<StoresCityModel>;
  city_id?: Maybe<Scalars['Float']['output']>;
  city_title?: Maybe<Scalars['String']['output']>;
  cln_id_old?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<CatalogCommentsModel>>;
  coords?: Maybe<Scalars['String']['output']>;
  courierItem?: Maybe<CourierModel>;
  courier_id?: Maybe<Scalars['Float']['output']>;
  cur_id?: Maybe<Scalars['Float']['output']>;
  dadataItem?: Maybe<DadataModel>;
  dadata_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryStoreItem?: Maybe<StoresModel>;
  delivery_cost?: Maybe<Scalars['Float']['output']>;
  delivery_date?: Maybe<Scalars['DateTimeISO']['output']>;
  delivery_id?: Maybe<Scalars['Float']['output']>;
  delivery_store_id?: Maybe<Scalars['Int']['output']>;
  delivery_title?: Maybe<Scalars['String']['output']>;
  digital?: Maybe<Scalars['Int']['output']>;
  digitalPromocodes?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<OrdersFieldModel>>;
  fio?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  fromPeopleEmail?: Maybe<Scalars['String']['output']>;
  fromPeopleFio?: Maybe<Scalars['String']['output']>;
  fromPeoplePhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inet_id_old?: Maybe<Scalars['Float']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  interval_id?: Maybe<Scalars['Float']['output']>;
  interval_title?: Maybe<Scalars['String']['output']>;
  /** @deprecated use secretKey */
  key?: Maybe<Scalars['String']['output']>;
  managerItem?: Maybe<OrdersManagersModel>;
  manager_comment?: Maybe<Scalars['String']['output']>;
  manager_id?: Maybe<Scalars['Int']['output']>;
  mng_id?: Maybe<Scalars['Float']['output']>;
  need_receipt?: Maybe<Scalars['Float']['output']>;
  one_click?: Maybe<Scalars['String']['output']>;
  opr_id?: Maybe<Scalars['Float']['output']>;
  ordBeg?: Maybe<Scalars['String']['output']>;
  ordEnd?: Maybe<Scalars['String']['output']>;
  ord_attr?: Maybe<Scalars['String']['output']>;
  ord_beg?: Maybe<Scalars['DateTimeISO']['output']>;
  ord_bns?: Maybe<Scalars['Float']['output']>;
  ord_bnsmns_old?: Maybe<Scalars['Float']['output']>;
  ord_bnspls_old?: Maybe<Scalars['Float']['output']>;
  ord_calcweight?: Maybe<Scalars['Float']['output']>;
  ord_date_old?: Maybe<Scalars['DateTimeISO']['output']>;
  ord_descr?: Maybe<Scalars['String']['output']>;
  ord_dscnt_old?: Maybe<Scalars['Float']['output']>;
  ord_end?: Maybe<Scalars['DateTimeISO']['output']>;
  ord_mark?: Maybe<Scalars['String']['output']>;
  ord_new?: Maybe<Scalars['String']['output']>;
  ord_pay?: Maybe<Scalars['Float']['output']>;
  ord_ship_old?: Maybe<Scalars['Float']['output']>;
  ord_state_old?: Maybe<Scalars['String']['output']>;
  ord_sum?: Maybe<Scalars['Float']['output']>;
  ord_weight?: Maybe<Scalars['Float']['output']>;
  ord_when_old?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Комментарии */
  orderCommentsList?: Maybe<CommentsItemUnion>;
  /** стоимость пакетов */
  orderContainerPrice?: Maybe<Scalars['Float']['output']>;
  orderLoyaltyItems: Array<OrderLoyaltyProgramModel>;
  ordersItems: Array<OrdersItemsModel>;
  paid?: Maybe<Scalars['String']['output']>;
  paid_date?: Maybe<Scalars['DateTimeISO']['output']>;
  paid_total?: Maybe<Scalars['Float']['output']>;
  paid_txn?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  paymentItem?: Maybe<OrdersPaymentsModel>;
  payment_id?: Maybe<Scalars['Int']['output']>;
  payment_title?: Maybe<Scalars['String']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  peopleToken?: Maybe<Scalars['String']['output']>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  positionsAmount?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  promocodeItem?: Maybe<PromocodesModel>;
  promocode_id?: Maybe<Scalars['Float']['output']>;
  promocodesItems?: Maybe<Array<PromocodesModel>>;
  recipeUrl?: Maybe<Scalars['String']['output']>;
  region_city_id?: Maybe<Scalars['Float']['output']>;
  rgn_id?: Maybe<Scalars['Float']['output']>;
  /** Маршрутные листы */
  routesheetItem?: Maybe<OrdersRoutesheetModel>;
  secretKey?: Maybe<Scalars['String']['output']>;
  /** Услуги */
  servicesItems?: Maybe<Array<OrdersServicesModel>>;
  sk_num?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  statusItem?: Maybe<OrdersStatusesModel>;
  status_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  /** Номер стола для барного заказа */
  table?: Maybe<Scalars['Int']['output']>;
  testDriveItem: OrdersTestDrivesModel;
  /** Сумма заказа с учетом стоимости услуг, но без стоимости доставки, промокодов, баллов */
  totalOrderItemsPrice: Scalars['Float']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  us_id?: Maybe<Scalars['Float']['output']>;
  us_saver?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  war_descr?: Maybe<Scalars['String']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type OrdersPaymentsModel = {
  __typename?: 'OrdersPaymentsModel';
  active?: Maybe<Scalars['String']['output']>;
  api_active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  is_blocking?: Maybe<Scalars['Int']['output']>;
  is_digital?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  max_price?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  ord_descr?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  ptp_del?: Maybe<Scalars['String']['output']>;
  ptp_descr?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_short?: Maybe<Scalars['String']['output']>;
  title_short_admin?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  ympt?: Maybe<Scalars['String']['output']>;
};

export type OrdersRoutesheetModel = {
  __typename?: 'OrdersRoutesheetModel';
  barcode?: Maybe<Scalars['String']['output']>;
  car?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  routesheet?: Maybe<Scalars['String']['output']>;
};

export type OrdersServicesModel = {
  __typename?: 'OrdersServicesModel';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Float']['output'];
  is_for_manager?: Maybe<Scalars['Float']['output']>;
  is_subscription?: Maybe<Scalars['Float']['output']>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type OrdersStatusesModel = {
  __typename?: 'OrdersStatusesModel';
  active?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  short_title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OrdersTestDrivesModel = {
  __typename?: 'OrdersTestDrivesModel';
  catalogItem: CatalogModel;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  orderItem: OrdersModel;
  order_id?: Maybe<Scalars['Int']['output']>;
  testDriveItem: TestDriveModel;
  test_drive_id?: Maybe<Scalars['Float']['output']>;
};

export type OrdersUnion = {
  __typename?: 'OrdersUnion';
  cartItem?: Maybe<OrderCartUnion>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type ParticipantsCharityUnion = {
  __typename?: 'ParticipantsCharityUnion';
  amount?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  people?: Maybe<PeopleItemCharityUnion>;
};

export type PeopleAddressesModel = {
  __typename?: 'PeopleAddressesModel';
  cad_addr_old?: Maybe<Scalars['String']['output']>;
  cad_del?: Maybe<Scalars['String']['output']>;
  cad_descr?: Maybe<Scalars['String']['output']>;
  cad_name?: Maybe<Scalars['String']['output']>;
  cad_person?: Maybe<Scalars['String']['output']>;
  cad_sms?: Maybe<Scalars['String']['output']>;
  cad_tel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Справочник городов, - регион адреса брать из region_city_id */
  city_id?: Maybe<Scalars['Int']['output']>;
  cln_id?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  confirmedByUser?: Maybe<Scalars['Boolean']['output']>;
  coords?: Maybe<Scalars['String']['output']>;
  dadata?: Maybe<DadataModel>;
  dadataItem?: Maybe<DadataModel>;
  dadata_id?: Maybe<Scalars['Float']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_confirmed_by_user?: Maybe<Scalars['Int']['output']>;
  is_primary?: Maybe<Scalars['Float']['output']>;
  is_recognised_by_dadata?: Maybe<Scalars['Float']['output']>;
  new_title?: Maybe<Scalars['String']['output']>;
  old_id?: Maybe<Scalars['Float']['output']>;
  old_title?: Maybe<Scalars['String']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  region_city_id?: Maybe<Scalars['Int']['output']>;
  rgn_id?: Maybe<Scalars['Float']['output']>;
  /** магазин пункта самовывоза; у адресов доставки пустой */
  store_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  timeid?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PeopleBillLogModel = {
  __typename?: 'PeopleBillLogModel';
  amount?: Maybe<Scalars['Float']['output']>;
  billItem?: Maybe<PeopleBillModel>;
  bill_id?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  news_id?: Maybe<Scalars['Float']['output']>;
  order_id?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PeopleBillModel = {
  __typename?: 'PeopleBillModel';
  bill?: Maybe<Scalars['Float']['output']>;
  billAmount?: Maybe<Scalars['Int']['output']>;
  billLogItem?: Maybe<Array<PeopleBillLogModel>>;
  id: Scalars['ID']['output'];
  new_bill?: Maybe<Scalars['Float']['output']>;
  old_bill?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
};

export type PeopleCharityInput = {
  /** сумма пожертвований */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** news */
  object?: InputMaybe<Scalars['String']['input']>;
  /** Id статьи */
  objectId?: InputMaybe<Scalars['Float']['input']>;
};

export type PeopleCharityUnion = {
  __typename?: 'PeopleCharityUnion';
  data?: Maybe<DataPeopleCharityUnion>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type PeopleFieldsModel = {
  __typename?: 'PeopleFieldsModel';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PeopleInput = {
  birthday?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fio?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profile_id?: InputMaybe<Scalars['Int']['input']>;
};

export type PeopleItemCharityUnion = {
  __typename?: 'PeopleItemCharityUnion';
  fio?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCurrentUser?: Maybe<Scalars['Boolean']['output']>;
};

export type PeopleModel = {
  __typename?: 'PeopleModel';
  access_email?: Maybe<Scalars['Boolean']['output']>;
  access_sms?: Maybe<Scalars['Float']['output']>;
  activated?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Array<PeopleAddressesModel>>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  averageReviewRating?: Maybe<Scalars['Float']['output']>;
  bill?: Maybe<PeopleBillModel>;
  billItem?: Maybe<PeopleBillModel>;
  birthday?: Maybe<Scalars['DateTimeISO']['output']>;
  birthdayDate?: Maybe<Scalars['DateTimeISO']['output']>;
  can_invite?: Maybe<Scalars['Float']['output']>;
  cartCookieId?: Maybe<Scalars['String']['output']>;
  cln_del?: Maybe<Scalars['String']['output']>;
  cln_name?: Maybe<Scalars['String']['output']>;
  cln_spam?: Maybe<Scalars['String']['output']>;
  cnt_favorites?: Maybe<Scalars['Float']['output']>;
  cookie_id?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  favoriteRubric?: Maybe<CatalogTypesModel>;
  fb_id?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info: Scalars['String']['output'];
  isSubscribedToEmail?: Maybe<Scalars['Boolean']['output']>;
  isSubscribedToPromo?: Maybe<Scalars['Boolean']['output']>;
  isSubscribedToSms?: Maybe<Scalars['Boolean']['output']>;
  is_new_loyalty_program?: Maybe<Scalars['Boolean']['output']>;
  landline_phone?: Maybe<Scalars['String']['output']>;
  lastBonusPayment?: Maybe<Scalars['Int']['output']>;
  last_date?: Maybe<Scalars['DateTimeISO']['output']>;
  login_locked?: Maybe<Scalars['String']['output']>;
  login_locked_date?: Maybe<Scalars['DateTimeISO']['output']>;
  lvl_id?: Maybe<Scalars['Float']['output']>;
  min_auth_time?: Maybe<Scalars['Float']['output']>;
  min_order_price?: Maybe<Scalars['Float']['output']>;
  mng_id?: Maybe<Scalars['Float']['output']>;
  ok_id?: Maybe<Scalars['String']['output']>;
  opr_id?: Maybe<Scalars['Float']['output']>;
  ordersItem?: Maybe<Array<OrdersModel>>;
  partner_id?: Maybe<Scalars['Int']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  peopleProfileItem?: Maybe<PeopleProfileModel>;
  phone?: Maybe<Scalars['String']['output']>;
  postponed_quantity?: Maybe<Scalars['Float']['output']>;
  profile_id?: Maybe<Scalars['Int']['output']>;
  sb_sub?: Maybe<Scalars['String']['output']>;
  send_recipes?: Maybe<Scalars['Float']['output']>;
  settingsItem?: Maybe<PeopleSettingsModel>;
  statsItem?: Maybe<PeopleStatsModel>;
  statusItem?: Maybe<PeopleStatusModel>;
  status_id?: Maybe<Scalars['Int']['output']>;
  subscibe_promo?: Maybe<Scalars['Boolean']['output']>;
  subscriptionItems?: Maybe<Array<SubscribersModel>>;
  totalComments?: Maybe<Scalars['Float']['output']>;
  totalOrders?: Maybe<Scalars['Int']['output']>;
  totalReviews?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vk_id?: Maybe<Scalars['String']['output']>;
  wrongLogins?: Maybe<Scalars['Float']['output']>;
};

export type PeopleNewsCharityUnion = {
  __typename?: 'PeopleNewsCharityUnion';
  donation?: Maybe<Scalars['Float']['output']>;
  entity?: Maybe<NewsModel>;
  peopleId?: Maybe<Scalars['Float']['output']>;
};

export type PeopleProfileModel = {
  __typename?: 'PeopleProfileModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  parent_id?: Maybe<Scalars['Float']['output']>;
  pct?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_2?: Maybe<Scalars['String']['output']>;
  typesList?: Maybe<Array<CatalogTypesModel>>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PeopleRecycleUnion = {
  __typename?: 'PeopleRecycleUnion';
  amount?: Maybe<Scalars['Float']['output']>;
  button?: Maybe<Scalars['String']['output']>;
  peopleId?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<ServicesModel>;
};

export type PeopleReplyUnion = {
  __typename?: 'PeopleReplyUnion';
  /** сообщение об ошибке */
  error?: Maybe<Scalars['String']['output']>;
  /** код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Информация об операции */
  info?: Maybe<Scalars['String']['output']>;
  /** Информация об операции */
  people?: Maybe<PeopleModel>;
  /** флаг существует ли пользователь */
  peopleExist?: Maybe<Scalars['Boolean']['output']>;
  /** результат выполнения операции */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PeopleSettingsModel = {
  __typename?: 'PeopleSettingsModel';
  accept_auto_payment?: Maybe<Scalars['Boolean']['output']>;
  catalog_sorting?: Maybe<Scalars['String']['output']>;
  epp_catalog?: Maybe<Scalars['Int']['output']>;
  is_order_notify_messengers?: Maybe<Scalars['Int']['output']>;
  is_order_notify_sms?: Maybe<Scalars['Int']['output']>;
  need_digital_receipt?: Maybe<Scalars['Boolean']['output']>;
  pay_over_weight_with_bonuses?: Maybe<Scalars['Boolean']['output']>;
  pay_tip_with_bonuses?: Maybe<Scalars['Boolean']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  save_payment_card?: Maybe<Scalars['Boolean']['output']>;
};

/** тип действия с пользователем */
export enum PeopleSmsAction {
  Bonuses = 'BONUSES',
  Email = 'EMAIL',
  Flashcall = 'FLASHCALL',
  Login = 'LOGIN',
  Register = 'REGISTER',
  Tgauth = 'TGAUTH'
}

export type PeopleStatsModel = {
  __typename?: 'PeopleStatsModel';
  first_order_date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  prev_order_date?: Maybe<Scalars['DateTimeISO']['output']>;
  prev_order_price?: Maybe<Scalars['Float']['output']>;
  total_orders?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
};

export type PeopleStatusModel = {
  __typename?: 'PeopleStatusModel';
  active?: Maybe<Scalars['String']['output']>;
  cst_del?: Maybe<Scalars['String']['output']>;
  cst_ship?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  descr?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  intermediate_discount?: Maybe<Scalars['Float']['output']>;
  intermediate_price?: Maybe<Scalars['Float']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PeopleSubscribtionUnion = {
  __typename?: 'PeopleSubscribtionUnion';
  available?: Maybe<Scalars['Boolean']['output']>;
  byEmail?: Maybe<Scalars['Boolean']['output']>;
  bySMS?: Maybe<Scalars['Boolean']['output']>;
  existing?: Maybe<SubscribeExistingUnion>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Подсказка по сумме заказа */
export type PossibleBonusUnion = {
  __typename?: 'PossibleBonusUnion';
  /** Разрешены ли подарки (если не разрешены, то не надо их отображать) */
  isGiftAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Ближайшая по сумме заказа программа лояльности */
  loyaltyProgram?: Maybe<LoyaltyProgramModel>;
  /** Максимальное значение */
  maxValue?: Maybe<Scalars['Int']['output']>;
  /** Разница в цене, после которой станет доступно максимальное значение */
  priceDifference?: Maybe<Scalars['Int']['output']>;
  /** Текущее значение */
  value?: Maybe<Scalars['Int']['output']>;
};

export type PostCardUnion = {
  __typename?: 'PostCardUnion';
  /** ID позации в корзине. */
  cartItemId?: Maybe<Scalars['Float']['output']>;
  /** ID товара. */
  catalogId?: Maybe<Scalars['Float']['output']>;
  /** ID ранее созданной открытки; если отстуствует, будет создана новая. */
  id?: Maybe<Scalars['Float']['output']>;
  /** От кого? */
  sender?: Maybe<Scalars['String']['output']>;
  /** Текст для открытки */
  text?: Maybe<Scalars['String']['output']>;
};

export type PostcardInput = {
  /** ID позации в корзине. */
  cartItemId?: InputMaybe<Scalars['Float']['input']>;
  /** ID ранее созданной открытки; если отстуствует, будет создана новая. */
  id?: InputMaybe<Scalars['Float']['input']>;
  /** От кого? */
  sender?: InputMaybe<Scalars['String']['input']>;
  /** Текст для открытки */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ProductAdditionalInfoUnion = {
  __typename?: 'ProductAdditionalInfoUnion';
  dataOldLoyaltyBonus?: Maybe<Scalars['Float']['output']>;
  dataProductPrice?: Maybe<Scalars['Float']['output']>;
  dataTooltip?: Maybe<Scalars['String']['output']>;
  productPageBonusSumm?: Maybe<Scalars['String']['output']>;
};

export type ProductRefundStatsUnion = {
  __typename?: 'ProductRefundStatsUnion';
  activeRefunds?: Maybe<Array<OrderRefundItemModel>>;
  itemsData?: Maybe<Array<OrderItemsContainersModel>>;
  /** макимальное доступное для возврата количество товара */
  maxRefundAmount?: Maybe<Scalars['Int']['output']>;
  /** макимальное период(в днях) возврата товара */
  maxRefundDays?: Maybe<Scalars['Int']['output']>;
  /** цена товара во время последней покупки */
  peoplePurchasedProductPrice?: Maybe<Scalars['Float']['output']>;
  refundPaymentType?: Maybe<Array<OrderPaymentRefundType>>;
};

export enum ProductSort {
  Alphabet = 'alphabet',
  Comments = 'comments',
  Date = 'date',
  Default = 'default',
  Discount = 'discount',
  Express = 'express',
  Id = 'id',
  Ids = 'ids',
  Newest = 'newest',
  Popular = 'popular',
  PriceDown = 'priceDown',
  PriceUp = 'priceUp',
  Rating = 'rating',
  Unordered = 'unordered'
}

/** Выбрать тип для комментария товара: отзыв/вопрос */
export enum ProductsCommentsTypeEnum {
  All = 'All',
  Comment = 'Comment',
  Review = 'Review'
}

export type PromocodeReplyUnion = {
  __typename?: 'PromocodeReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** промокод */
  promocodeItem?: Maybe<PromocodesModel>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type ProductAttributeType = {
  __typename?: 'ProductAttributeType';
  bool?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  number?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  unitCode?: Maybe<Scalars['String']['output']>;
  unitText?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  values: Array<ProductAttributeValueType>;
};

export type ProductAttributeValueType = {
  __typename?: 'ProductAttributeValueType';
  code: Scalars['String']['output'];
  schemaUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PromocodesModel = {
  __typename?: 'PromocodesModel';
  active?: Maybe<Scalars['String']['output']>;
  apply_many_times?: Maybe<Scalars['Float']['output']>;
  auto?: Maybe<Scalars['String']['output']>;
  canBeCancelled?: Maybe<Scalars['Int']['output']>;
  can_be_cancelled?: Maybe<Scalars['Float']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_amount?: Maybe<Scalars['Float']['output']>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  giftItem?: Maybe<CatalogModel>;
  gift_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  is_for_new_people?: Maybe<Scalars['Float']['output']>;
  is_mobile_only?: Maybe<Scalars['Float']['output']>;
  max_activations?: Maybe<Scalars['Float']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  people_id?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<CatalogModel>;
  promoCodeType?: Maybe<PromocodesTypesModel>;
  reservedList?: Maybe<Array<CartPromocodesModel>>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeItem?: Maybe<PromocodesTypesModel>;
  type_id?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PromocodesTypesModel = {
  __typename?: 'PromocodesTypesModel';
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PromotionUnion = {
  __typename?: 'PromotionUnion';
  promotion?: Maybe<PromotionsModel>;
  rubricMenuTree: Array<CatalogTypesModel>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PromotionsItemsModel = {
  __typename?: 'PromotionsItemsModel';
  amount?: Maybe<Scalars['Float']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  getAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  promotionItem?: Maybe<PromotionsModel>;
  sold?: Maybe<Scalars['Float']['output']>;
  timeid?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PromotionsModel = {
  __typename?: 'PromotionsModel';
  active?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  articlesList?: Maybe<Array<ArticlesModel>>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  bannersItem?: Maybe<Array<BannersModel>>;
  countPromotionItems?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  date_end?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  identifyIdURI?: Maybe<Scalars['String']['output']>;
  isAvaliable?: Maybe<Scalars['Boolean']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  profile_id?: Maybe<Scalars['Float']['output']>;
  promotionItems: Array<PromotionsItemsModel>;
  recipesList?: Maybe<Array<RecipesModel>>;
  sTime?: Maybe<Scalars['DateTimeISO']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  activeLoyaltyLevels: Array<LoyaltyProgramModel>;
  addDadata: DadataUnion;
  addSubscriber: Scalars['Boolean']['output'];
  aggregateGet: Scalars['String']['output'];
  allTestDriveTesters: Scalars['Float']['output'];
  availableForRefund: Scalars['Boolean']['output'];
  blabla: Scalars['String']['output'];
  callback: ReplyUnion;
  checkOrderPaid: Scalars['Boolean']['output'];
  checkPeopleExist: Scalars['Boolean']['output'];
  checkPeopleSubscription: SubscribersUnion;
  checkProductPeopleBuy: Scalars['String']['output'];
  checkProductPeopleBuyTEST: Array<Scalars['Float']['output']>;
  checkSBPStatus: CommonReplyUnion;
  checkSBPStatuses: CommonReplyUnion;
  /** clear auth cookie */
  clearCookie?: Maybe<Scalars['Boolean']['output']>;
  confirmOrderById?: Maybe<ConfirmOrderByIdUnion>;
  confirmSubscribe: ReplyUnion;
  contextGet: Scalars['Boolean']['output'];
  contextSet: Scalars['Boolean']['output'];
  countCacheKeys: Scalars['Float']['output'];
  countNewsItems: Scalars['Int']['output'];
  countPromotionsItems: Scalars['Int']['output'];
  countSalesNumber: Scalars['Float']['output'];
  cronListTasks: Array<CronTaskStatusGql>;
  delCache: Scalars['String']['output'];
  delCacheMultiple: Array<Scalars['String']['output']>;
  deleteCartTemplateItem?: Maybe<CabinetUnion>;
  feedback: ReplyUnion;
  findNewsAll: Array<NewsModel>;
  findNewsById: NewsModel;
  findNewsCommentsById: NewsUnion;
  findPromotionById: PromotionsModel;
  findPromotionByIdTemp: PromotionUnion;
  findPromotionsAll: Array<PromotionsModel>;
  findTestDriveAll: TestDriveUnion;
  flushCache: Scalars['String']['output'];
  getAchivement?: Maybe<Scalars['String']['output']>;
  getActiveAndOpensSoonStores: Array<StoresModel>;
  getAddressComments: CommentsItemUnion;
  getAllConnectedTypes: Array<Scalars['Int']['output']>;
  getAllReceivedTestDriveProducts: Array<CatalogModel>;
  /** получить аналоги товаров по массиву id */
  getAnalogsByCatalogIds: Array<CatalogAnalogsUnion>;
  getArticleById: ArticlesModel;
  getArticleRelatedArticles: Array<ArticlesModel>;
  getArticleRelatedCatalogItems: Array<CatalogModel>;
  getArticleRelatedRecipes: Array<RecipesModel>;
  getArticles: ArticlesUnion;
  getArticlesCommentsByArticleId: ArticlesUnion;
  getAuthor: RecipesAuthorModel;
  getAvailableServices?: Maybe<Scalars['String']['output']>;
  getAvailableTodayProducts: Array<CatalogModel>;
  getAverageReviewsRating: Scalars['Float']['output'];
  getBannerById?: Maybe<BannersModel>;
  getBarMenuTypes: Array<MenuTypesModel>;
  getBigBannerByPromotionId: Scalars['String']['output'];
  getBigBannerMainPage: Scalars['String']['output'];
  getBlogItemById: BlogModel;
  getBlogItems: Array<BlogModel>;
  getBreadcrumbsByRubricSlug: Array<CatalogTypesModel>;
  getCache: Scalars['String']['output'];
  getCacheKeys: Array<Scalars['String']['output']>;
  getCachesByPrefix: Array<Scalars['String']['output']>;
  getCart: CartModel;
  getCartShareData: CartShareDataUnion;
  getCartTemplatesList?: Maybe<CabinetUnion>;
  getCashbackAmountForPickUp: Scalars['Float']['output'];
  getCatalogAnalogs: Array<CatalogModel>;
  getCatalogItems: CatalogUnion;
  getCatalogItemsByPromotionId: Array<CatalogModel>;
  getCatalogMainMenu: Array<CatalogTypesModel>;
  getCharityDonations?: Maybe<PeopleCharityUnion>;
  getChilds: Array<CatalogTypesModel>;
  getCommentList: Array<CommentsModel>;
  getComments: RecipesUnion;
  getDefaultNearestDelivery: CatalogDeliveryUnion;
  getDeliveryCloseInfo: DeliveryCloseInfoReplyUnion;
  getDigi?: Maybe<Scalars['String']['output']>;
  getFaqsAll: FaqUnion;
  getFeedXml: Scalars['String']['output'];
  getFullFile: Scalars['String']['output'];
  getFullFileFetch: Scalars['String']['output'];
  getImageTypes: Array<AttachmentsTypesModel>;
  getImg: CatalogModel;
  /**
   * deprecation! Общий объединенный метод. Reason: Слишком времязатратный - был разбит на два отдельных: getIndexCore и getIndexAddition
   * @deprecated Слишком времязатратный - был разбит на два отдельных: getIndexCore и getIndexAddition
   */
  getIndex: IndexUnion;
  /** Получить блоки "Рекомендуем" и "Вас заинтересуют" для главной страницы */
  getIndexAddition: IndexAdditionUnion;
  /** Получить все блоки главной страницы за исключением "Рекомендуем", "Вас заинтересуют", "Отзывы" */
  getIndexCore: IndexCoreUnion;
  /** Получить блок с отзывами для главной страницы */
  getIndexReviews: IndexReviewsUnion;
  getInitFileFetch: Scalars['String']['output'];
  getLinkForAccessCode: LinkForAccessCodeReplyUnion;
  getMCache: Array<Scalars['String']['output']>;
  /** Нарезанные картинки с фильтром h315 тут fileItem {cacheItem {filePath}} */
  getMainPageBanners: Array<BannersModel>;
  getMenuSpecial?: Maybe<Array<TopMenuSpecialModel>>;
  getMenuTreeBySlug: Array<CatalogTypesModel>;
  getMobileMenuTree: Array<CatalogTypesModel>;
  getMyFaqsCount: Scalars['Float']['output'];
  getNewbeeItems: Array<CatalogModel>;
  getNewbeeProducts: Array<CatalogModel>;
  getNewsWithPeopleCharityDonations?: Maybe<Array<PeopleNewsCharityUnion>>;
  getNutritionalValues: CatalogModel;
  getOrderAndAddressComments: CommentsOrderAddressUnion;
  getOrderComments: CommentsItemUnion;
  getOrdersThatUserCanChange?: Maybe<Array<Scalars['Float']['output']>>;
  getOrganizationRating: Scalars['Float']['output'];
  getPdfLink: Scalars['String']['output'];
  getPeopleActiveTasksCount?: Maybe<Scalars['Float']['output']>;
  getPeopleAvalTasksCount?: Maybe<Scalars['Float']['output']>;
  getPeopleBillAmount?: Maybe<PeopleBillModel>;
  getPeopleBillLog?: Maybe<CabinetUnion>;
  getPeopleFavoritesProducts?: Maybe<CabinetUnion>;
  getPeopleLastDeliveredOrderId?: Maybe<Scalars['Float']['output']>;
  getPeopleOrderById?: Maybe<CabinetUnion>;
  getPeopleOrders?: Maybe<CabinetUnion>;
  getPeopleProducts?: Maybe<CabinetUnion>;
  getPeopleProfile?: Maybe<CabinetUnion>;
  getPeopleRecipes?: Maybe<CabinetUnion>;
  getPeopleRecycleStats?: Maybe<Array<PeopleRecycleUnion>>;
  getPeopleReviews?: Maybe<CabitetReviewsReplyUnion>;
  getPeopleSearchQueries?: Maybe<Array<SearchQueriesModel>>;
  getPeopleSettings?: Maybe<CabinetUnion>;
  getPopularArticles: ArticlesUnion;
  getPopularItems: Array<CatalogModel>;
  getPopularMainPageItems: Array<CatalogModel>;
  getPopularQueriesAndCategories: SearchBoosterPopularQueriesAndCategories;
  getPostcards: GetPostCardReplyUnion;
  getProductAlsoboughtAndRecommend: CatalogModel;
  getProductById: CatalogModel;
  getProductByIdTemp: CatalogModel;
  getProductCommentsById: CatalogUnion;
  getProductRecipesById: RecipesUnion;
  getProductSubs: CatalogSubsUnion;
  getProductVariants: Array<CatalogModel>;
  getProductWithAmounts: CatalogModel;
  getProducts: CatalogUnion;
  getProductsByIds: Array<CatalogModel>;
  getProductsBySearchBooster: CatalogUnion;
  getProductsBySupplierId: GetProductsBySupplierIdUnion;
  getProductsListByIds: CatalogUnion;
  getPromoRecipesByProductId: Array<RecipesModel>;
  getPromocodeInfo: PromocodeReplyUnion;
  getRangeById: AreasModel;
  getRanges: Array<AreasModel>;
  getRecipeById: RecipesModel;
  getRecipeCommentsByRecipeId: RecipesUnion;
  getRecipesFilters: RecipesUnion;
  getRecipesMainPage: Array<RecipesModel>;
  getRecipesPopular: Array<RecipesModel>;
  getRecipesRecommend: Array<RecipesModel>;
  getRecipesTesty: Array<RecipesModel>;
  getRecipesVideoCodes: Array<Scalars['String']['output']>;
  getRecipesWithFilters: RecipesUnion;
  getRecipesWithFiltersOld: RecipesUnion;
  getRecommendItems: Array<CatalogModel>;
  getRecommendationsToCart: CartRecommendUnion;
  getRecommendedByStore: CatalogUnion;
  getRedirectsActive: Array<RedirectsModel>;
  getReviewTagList: Array<ReviewsTagsModel>;
  getReviewsAll: ReviewsUnion;
  getReviewsRating: Array<Scalars['Int']['output']>;
  getRubricBanners: Array<BannersModel>;
  getSBPLink: SbpReplyUnion;
  getSaleSectionProducts: SaleSectionProductsReplyUnion;
  getSb?: Maybe<CommonReplyUnion>;
  getSearchExample: SearchExamplesReplyUnion;
  getSearchQueries?: Maybe<Array<Scalars['String']['output']>>;
  getShareCart: CartShareModel;
  getStories: Array<StoriesModel>;
  getStoriesByPromotionId: Array<StoriesModel>;
  getSubscribersModel: Array<SubscribersModel>;
  getTTlCache: Scalars['String']['output'];
  getTaskById?: Maybe<TaskPeopleModel>;
  getTaskByProductId: TasksReplyUnion;
  getTasks: TasksReplyUnion;
  getTestDriveById: TestDriveModel;
  getTestDriveProductsStats: TestDriveStatsUnion;
  getTestDrivesCount: Scalars['Float']['output'];
  /** получить промо товар для спасибо за покупку */
  getThankYouPromotionProduct: CatalogModel;
  /** получить промо товар для спасибо за покупку */
  getThankYouPromotionProducts: Array<CatalogModel>;
  getTopMenu: Array<TopMenuModel>;
  getTopNewestReviews: Array<CatalogCommentsModel>;
  getTypesBlogItems: Array<BlogTypesModel>;
  getVacancies: Array<VacancyModel>;
  getVacancy: VacancyReplyUnion;
  hasCache: Scalars['String']['output'];
  hello?: Maybe<Scalars['String']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isAvailableForPurchase: Scalars['Boolean']['output'];
  isAval: Scalars['Boolean']['output'];
  isProductHasAttachmentInComments: Scalars['Boolean']['output'];
  joinQueries: CatalogUnion;
  loggerFacadeLog: Scalars['String']['output'];
  makePassword: Scalars['String']['output'];
  maxAvailableAmount?: Maybe<Scalars['Int']['output']>;
  me?: Maybe<PeopleModel>;
  metaGet: Scalars['String']['output'];
  multiSave: Scalars['String']['output'];
  oneSignalSpamCheck: ReplyUnion;
  orderHistoryProductStats: OrderHistoryPercentStatsUnion;
  parseNutritionalValue: Scalars['String']['output'];
  peopleCommentsStats?: Maybe<Array<GetPeopleCommentStats>>;
  prepareItems: Array<CatalogModel>;
  printCache: ReplyUnion;
  productRefundStats?: Maybe<ProductRefundStatsUnion>;
  queryCatalogFaq: Array<CatalogFaqItemUnion>;
  refundCommentsList: Array<RefundCommentListModel>;
  refundPaymentType: Array<OrderPaymentRefundType>;
  sendClaim: CommonReplyUnion;
  sendCourierLandingPageEmail: CommonReplyUnion;
  sendEmailForCatering: CommonReplyUnion;
  sendEmailForCourierLandingPage: CommonReplyUnion;
  sendEmailForFranchise: CommonReplyUnion;
  sendEmailForTableBooking: CommonReplyUnion;
  setCache: Scalars['String']['output'];
  setCatalogRubricSeo?: Maybe<Scalars['String']['output']>;
  setImgByLink?: Maybe<Scalars['String']['output']>;
  setPdf?: Maybe<Scalars['String']['output']>;
  test: Scalars['String']['output'];
  testAddressAvailableForDelivery: Scalars['String']['output'];
  testAsync: Scalars['String']['output'];
  testAsyncAwait: Scalars['String']['output'];
  testAttach?: Maybe<Scalars['String']['output']>;
  testCatalog?: Maybe<Scalars['String']['output']>;
  testFields: PeopleFieldsModel;
  testGet: Scalars['String']['output'];
  testLogger: Scalars['String']['output'];
  testRedConnection: Scalars['String']['output'];
  testSendEmail: Scalars['String']['output'];
  testSendNotification: Scalars['String']['output'];
  testTimeCache: Scalars['String']['output'];
  testVarLog: Scalars['Boolean']['output'];
  testtypeById: Array<CatalogTypesModel>;
  /** @deprecated no more cookie for X-Store-Id */
  updatePeopleStoreId?: Maybe<Scalars['String']['output']>;
  uploadImg?: Maybe<Scalars['String']['output']>;
  uploadImg1?: Maybe<Scalars['String']['output']>;
  uploadImg2?: Maybe<Scalars['String']['output']>;
};


export type QueryAddDadataArgs = {
  data: DadataInput;
};


export type QueryAddSubscriberArgs = {
  source?: Scalars['String']['input'];
  subscribeEmail: Scalars['String']['input'];
  subscribe_type?: Scalars['String']['input'];
};


export type QueryAggregateGetArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailableForRefundArgs = {
  catalogId: Scalars['Int']['input'];
};


export type QueryBlablaArgs = {
  length?: Scalars['Float']['input'];
};


export type QueryCallbackArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  fio: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckOrderPaidArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckPeopleExistArgs = {
  email: Scalars['String']['input'];
};


export type QueryCheckPeopleSubscriptionArgs = {
  productId: Scalars['Float']['input'];
  subscription_type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckProductPeopleBuyArgs = {
  catalogId?: Scalars['Float']['input'];
  peopleId?: Scalars['Float']['input'];
};


export type QueryCheckProductPeopleBuyTestArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckSbpStatusArgs = {
  paymentId: Scalars['Int']['input'];
};


export type QueryCheckSbpStatusesArgs = {
  paymentId: Scalars['Float']['input'];
};


export type QueryConfirmOrderByIdArgs = {
  hash: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};


export type QueryConfirmSubscribeArgs = {
  hash?: InputMaybe<Scalars['String']['input']>;
  peopleId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContextGetArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type QueryContextSetArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type QueryCountCacheKeysArgs = {
  key?: Scalars['String']['input'];
};


export type QueryCountSalesNumberArgs = {
  catalogId: Scalars['Float']['input'];
};


export type QueryDelCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDelCacheMultipleArgs = {
  key?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDeleteCartTemplateItemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFeedbackArgs = {
  captcha?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fio: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindNewsAllArgs = {
  excludeId?: Scalars['Int']['input'];
  fromDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryFindNewsByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFindNewsCommentsByIdArgs = {
  id: Scalars['Int']['input'];
  orderBy?: Scalars['String']['input'];
  orderDir?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryFindPromotionByIdArgs = {
  id: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryFindPromotionByIdTempArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identify?: InputMaybe<Scalars['String']['input']>;
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindPromotionsAllArgs = {
  fromDate?: Scalars['DateTimeISO']['input'];
  fromDateEnd?: Scalars['DateTimeISO']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setOrder?: Scalars['String']['input'];
};


export type QueryFindTestDriveAllArgs = {
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setSort?: Scalars['String']['input'];
};


export type QueryGetAchivementArgs = {
  achivement_id?: Scalars['String']['input'];
  people?: Scalars['String']['input'];
};


export type QueryGetActiveAndOpensSoonStoresArgs = {
  shopType?: InputMaybe<ShopType>;
};


export type QueryGetAddressCommentsArgs = {
  addressId: Scalars['Int']['input'];
};


export type QueryGetAllConnectedTypesArgs = {
  typeId: Scalars['Int']['input'];
};


export type QueryGetAnalogsByCatalogIdsArgs = {
  catalogIds: Array<Scalars['Int']['input']>;
  epp?: Scalars['Int']['input'];
};


export type QueryGetArticleByIdArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetArticleRelatedArticlesArgs = {
  articleId: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetArticleRelatedCatalogItemsArgs = {
  articleId: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetArticleRelatedRecipesArgs = {
  articleId: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetArticlesArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetArticlesCommentsByArticleIdArgs = {
  id: Scalars['ID']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetAuthorArgs = {
  identify: Scalars['String']['input'];
};


export type QueryGetAvailableServicesArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  peopleId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetAvailableTodayProductsArgs = {
  amountGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  productIds: Array<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAverageReviewsRatingArgs = {
  force?: Scalars['Boolean']['input'];
};


export type QueryGetBannerByIdArgs = {
  bannerId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBarMenuTypesArgs = {
  menuStoreId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBigBannerByPromotionIdArgs = {
  id: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetBigBannerMainPageArgs = {
  id: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetBlogItemByIdArgs = {
  id: Scalars['ID']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetBlogItemsArgs = {
  imageSizeFilter?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setType?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBreadcrumbsByRubricSlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCacheKeysArgs = {
  key?: Scalars['String']['input'];
};


export type QueryGetCachesByPrefixArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCartArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCartShareDataArgs = {
  cartShareLink?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCartTemplatesListArgs = {
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetCatalogAnalogsArgs = {
  catalogId?: InputMaybe<Scalars['Int']['input']>;
  epp?: Scalars['Int']['input'];
};


export type QueryGetCatalogItemsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setOrder?: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryGetCatalogItemsByPromotionIdArgs = {
  fromCatalogId?: Scalars['Int']['input'];
  fromRating?: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  promoId?: InputMaybe<Scalars['Int']['input']>;
  setLimit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCatalogMainMenuArgs = {
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetCharityDonationsArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  data: PeopleCharityInput;
};


export type QueryGetChildsArgs = {
  catalogURL: Scalars['String']['input'];
  isMenu?: Scalars['Boolean']['input'];
  withChildren?: Scalars['Boolean']['input'];
};


export type QueryGetCommentsArgs = {
  id: Scalars['ID']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Float']['input'];
  setLimit?: Scalars['Float']['input'];
};


export type QueryGetDeliveryCloseInfoArgs = {
  forceCache?: Scalars['Boolean']['input'];
};


export type QueryGetDigiArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFaqsAllArgs = {
  active?: Scalars['String']['input'];
  authorIdFilter?: InputMaybe<Scalars['Float']['input']>;
  imageSizeFilter?: Scalars['String']['input'];
  mePeopleIdFilter?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['Int']['input'];
  peopleId?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetFeedXmlArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  bar?: InputMaybe<Scalars['Boolean']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  gis2?: InputMaybe<Scalars['Boolean']['input']>;
  store_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFullFileArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  filter?: Scalars['String']['input'];
  productId: Scalars['Float']['input'];
};


export type QueryGetFullFileFetchArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  filter?: Scalars['String']['input'];
  productId: Scalars['Float']['input'];
};


export type QueryGetImgArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  filter?: Scalars['String']['input'];
  key?: Scalars['Float']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetIndexArgs = {
  bannersLimit?: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  pofdLimit?: Scalars['Int']['input'];
  productsLimit?: Scalars['Int']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  recipesLimit?: Scalars['Int']['input'];
  reviewsLimit?: Scalars['Int']['input'];
};


export type QueryGetIndexAdditionArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  imageSizeFilter?: Scalars['String']['input'];
  productsLimit?: Scalars['Int']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetIndexCoreArgs = {
  bannersImageSize?: Scalars['String']['input'];
  bannersLimit?: InputMaybe<Scalars['Int']['input']>;
  blocksFilter?: Array<Scalars['String']['input']>;
  cartToken?: InputMaybe<Scalars['String']['input']>;
  imageSizeFilter?: Scalars['String']['input'];
  pofdLimit?: Scalars['Int']['input'];
  productsLimit?: Scalars['Int']['input'];
  recipesLimit?: Scalars['Int']['input'];
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetIndexReviewsArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  reviewsLimit?: Scalars['Int']['input'];
};


export type QueryGetInitFileFetchArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  filter?: Scalars['String']['input'];
  productId: Scalars['Float']['input'];
};


export type QueryGetMCacheArgs = {
  key?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetMainPageBannersArgs = {
  setLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMenuTreeBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetMobileMenuTreeArgs = {
  device?: Scalars['String']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  is18plus?: Scalars['Boolean']['input'];
  isFull?: Scalars['Boolean']['input'];
  isMenu?: Scalars['Boolean']['input'];
  menuStoreId?: InputMaybe<Scalars['Int']['input']>;
  menuTypeId?: InputMaybe<Scalars['String']['input']>;
  onlySpecial?: Scalars['Boolean']['input'];
  withChildren?: Scalars['Boolean']['input'];
};


export type QueryGetMyFaqsCountArgs = {
  active?: Scalars['String']['input'];
};


export type QueryGetNewbeeItemsArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetNewbeeProductsArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetNewsWithPeopleCharityDonationsArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  peopleId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetNutritionalValuesArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryGetOrderAndAddressCommentsArgs = {
  addressId?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOrderCommentsArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOrdersThatUserCanChangeArgs = {
  xPeopleToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPdfLinkArgs = {
  recipeId: Scalars['Int']['input'];
};


export type QueryGetPeopleBillLogArgs = {
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetPeopleOrderByIdArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  includeRecipes?: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
  withServices?: Scalars['Boolean']['input'];
};


export type QueryGetPeopleOrdersArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  filter?: GetPeopleOrdersFilters;
  includeRecipes?: Scalars['Boolean']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  withServices?: Scalars['Boolean']['input'];
};


export type QueryGetPeopleProductsArgs = {
  identify?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  setLimit?: Scalars['Int']['input'];
  whatProducts?: Scalars['String']['input'];
};


export type QueryGetPeopleRecipesArgs = {
  bludo?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetPeopleRecycleStatsArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  peopleId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetPeopleReviewsArgs = {
  page?: Scalars['Int']['input'];
  productCommentType?: ProductsCommentsTypeEnum;
  setLimit?: Scalars['Int']['input'];
  setSort?: ReviewSortEnum;
  storeOrProductCommentType?: StoreOrProductCommentsTypeEnum;
};


export type QueryGetPeopleSearchQueriesArgs = {
  limit?: Scalars['Float']['input'];
};


export type QueryGetPopularArticlesArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetPopularItemsArgs = {
  force?: Scalars['Boolean']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  onMainPage?: Scalars['Boolean']['input'];
  setLimit?: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPopularMainPageItemsArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetPostcardsArgs = {
  cartItemId: Scalars['Float']['input'];
};


export type QueryGetProductAlsoboughtAndRecommendArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  isMenu?: Scalars['Boolean']['input'];
  menuStoreId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryGetProductByIdArgs = {
  additionFields?: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  isPrepareVideoFromText?: Scalars['Boolean']['input'];
};


export type QueryGetProductByIdTempArgs = {
  additionFields?: Scalars['Boolean']['input'];
  cartToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isMenu?: Scalars['Boolean']['input'];
  isPrepareVideoFromText?: Scalars['Boolean']['input'];
  menuStoreId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProductCommentsByIdArgs = {
  blocksFilter?: Array<Scalars['String']['input']>;
  catalogId?: InputMaybe<Scalars['Int']['input']>;
  commentType?: CommentsTypeTypeEnum;
  mainRubricId?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  peopleId?: InputMaybe<Scalars['Int']['input']>;
  setLimit?: Scalars['Int']['input'];
  setSort?: Scalars['String']['input'];
  withFile?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetProductRecipesByIdArgs = {
  catalogId: Scalars['Int']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: InputMaybe<Scalars['Int']['input']>;
  setSort?: Scalars['String']['input'];
};


export type QueryGetProductVariantsArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryGetProductWithAmountsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetProductsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  imageSizeFilter?: InputMaybe<Scalars['String']['input']>;
  isExpress?: InputMaybe<Scalars['Boolean']['input']>;
  menuStoreId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onMainPage?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setOrder?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specOffer?: InputMaybe<Scalars['String']['input']>;
  specOfferFirst?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  withUserSettings?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetProductsByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['Float']['input']>>;
  imageSizeFilter?: Scalars['String']['input'];
  withImages?: Scalars['Boolean']['input'];
  withPackageFirst?: Scalars['Boolean']['input'];
};


export type QueryGetProductsBySearchBoosterArgs = {
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  filters?: InputMaybe<AppliedFilters>;
  isFullSearch?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ProductSort>;
  orderDir?: InputMaybe<OrderDir>;
  productsSize?: InputMaybe<AppliedFilters>;
  userInput?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProductsBySupplierIdArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setOrder?: InputMaybe<Scalars['String']['input']>;
  specOffer?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['Int']['input'];
  withUserSettings?: Scalars['Boolean']['input'];
};


export type QueryGetProductsListByIdsArgs = {
  filters?: InputMaybe<AppliedFilters>;
  ids?: InputMaybe<Array<Scalars['Float']['input']>>;
  imageSizeFilter?: Scalars['String']['input'];
  orderBy?: InputMaybe<ProductSort>;
  orderDir?: InputMaybe<OrderDir>;
  setOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPromoRecipesByProductIdArgs = {
  allRecipes?: Scalars['Boolean']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};


export type QueryGetPromocodeInfoArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetRangeByIdArgs = {
  identify?: InputMaybe<Scalars['String']['input']>;
  rangeId?: InputMaybe<Scalars['Int']['input']>;
  title_short?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecipeByIdArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  imageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetRecipeCommentsByRecipeIdArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Float']['input'];
  setLimit?: Scalars['Float']['input'];
};


export type QueryGetRecipesMainPageArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetRecipesPopularArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetRecipesRecommendArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetRecipesTestyArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: Scalars['Float']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecipesWithFiltersArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  bludo?: InputMaybe<Scalars['Int']['input']>;
  imageSizeFilter?: Scalars['String']['input'];
  isProductPromo?: InputMaybe<Scalars['Boolean']['input']>;
  naznachenie?: InputMaybe<Scalars['Int']['input']>;
  obrabotka?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  productsPromoIds?: Array<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  setLimit?: Scalars['Int']['input'];
  slozhnost?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecipesWithFiltersOldArgs = {
  bludo?: InputMaybe<Scalars['Int']['input']>;
  imageSizeFilter?: Scalars['String']['input'];
  naznachenie?: InputMaybe<Scalars['Int']['input']>;
  obrabotka?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  setLimit?: Scalars['Int']['input'];
  slozhnost?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecommendItemsArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetRecommendationsToCartArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetRecommendedByStoreArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  productsLimit?: Scalars['Int']['input'];
  storeId: Scalars['Int']['input'];
};


export type QueryGetRedirectsActiveArgs = {
  forceCache?: Scalars['Boolean']['input'];
};


export type QueryGetReviewsAllArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setSort?: InputMaybe<Scalars['String']['input']>;
  setSource?: Scalars['String']['input'];
};


export type QueryGetReviewsRatingArgs = {
  force?: Scalars['Boolean']['input'];
};


export type QueryGetRubricBannersArgs = {
  setLimit?: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  withChildren?: Scalars['Boolean']['input'];
};


export type QueryGetSbpLinkArgs = {
  order: Scalars['Int']['input'];
};


export type QueryGetSaleSectionProductsArgs = {
  identifiers?: Array<Scalars['String']['input']>;
  productsIds: Array<Scalars['Float']['input']>;
};


export type QueryGetSbArgs = {
  aToken?: Scalars['String']['input'];
};


export type QueryGetSearchExampleArgs = {
  forceCache?: Scalars['Boolean']['input'];
};


export type QueryGetSearchQueriesArgs = {
  limit?: Scalars['Float']['input'];
};


export type QueryGetShareCartArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStoriesArgs = {
  imageSizeSlide?: Scalars['String']['input'];
  imageSizeStory?: Scalars['String']['input'];
};


export type QueryGetStoriesByPromotionIdArgs = {
  imageSizeSlide?: Scalars['String']['input'];
  imageSizeStory?: Scalars['String']['input'];
  promotionId: Scalars['Float']['input'];
};


export type QueryGetSubscribersModelArgs = {
  isUseGdsCount?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
  notificationEvent?: Scalars['String']['input'];
  subscribersIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGetTTlCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTaskByIdArgs = {
  taskId: Scalars['Int']['input'];
};


export type QueryGetTaskByProductIdArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};


export type QueryGetTasksArgs = {
  imageSizeFilter?: Scalars['String']['input'];
  productsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGetTestDriveByIdArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  cataloImageSizeFilter?: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  testDriveImageSizeFilter?: Scalars['String']['input'];
};


export type QueryGetThankYouPromotionProductArgs = {
  date: Scalars['DateTime']['input'];
  orderId: Scalars['Int']['input'];
};


export type QueryGetThankYouPromotionProductsArgs = {
  date?: Scalars['DateTime']['input'];
  orderId: Scalars['Int']['input'];
};


export type QueryGetTopNewestReviewsArgs = {
  setLimit?: Scalars['Int']['input'];
};


export type QueryGetTypesBlogItemsArgs = {
  imageSizeFilter?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setType?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVacancyArgs = {
  id: Scalars['Float']['input'];
};


export type QueryHasCacheArgs = {
  anyKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsAvailableArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryIsAvailableForPurchaseArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryIsAvalArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryIsProductHasAttachmentInCommentsArgs = {
  catalogId: Scalars['Float']['input'];
};


export type QueryJoinQueriesArgs = {
  force?: Scalars['Boolean']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  imageSizeFilter?: Scalars['String']['input'];
  onMainPage?: Scalars['Boolean']['input'];
  page?: Scalars['Int']['input'];
  setLimit?: Scalars['Int']['input'];
  setOrder?: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  specOffer?: InputMaybe<Scalars['String']['input']>;
  specOfferFirst?: Scalars['Boolean']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLoggerFacadeLogArgs = {
  level?: Scalars['String']['input'];
  message?: Scalars['String']['input'];
  model?: Scalars['String']['input'];
  title?: Scalars['String']['input'];
};


export type QueryMakePasswordArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaxAvailableAmountArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  forWholeWeek?: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
  storeId: Scalars['Int']['input'];
};


export type QueryMetaGetArgs = {
  anyKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMultiSaveArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOneSignalSpamCheckArgs = {
  checkSubscription?: Scalars['Boolean']['input'];
};


export type QueryOrderHistoryProductStatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryParseNutritionalValueArgs = {
  macronutrientType: Macronutrients;
  nutritionalValue: Scalars['String']['input'];
};


export type QueryPeopleCommentsStatsArgs = {
  peopleId: Scalars['Int']['input'];
};


export type QueryPrepareItemsArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrintCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductRefundStatsArgs = {
  amount?: Scalars['Int']['input'];
  catalogId: Scalars['Int']['input'];
  orderItemId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQueryCatalogFaqArgs = {
  url: Scalars['String']['input'];
};


export type QuerySendClaimArgs = {
  INN?: InputMaybe<Scalars['String']['input']>;
  KPP?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendCourierLandingPageEmailArgs = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerySendEmailForCateringArgs = {
  dateTime: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerySendEmailForCourierLandingPageArgs = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerySendEmailForFranchiseArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerySendEmailForTableBookingArgs = {
  dateTime: Scalars['DateTime']['input'];
  guestsQuantity: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  storeId: Scalars['Int']['input'];
};


export type QuerySetCacheArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySetImgByLinkArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySetPdfArgs = {
  achivement_id?: Scalars['String']['input'];
  people?: Scalars['String']['input'];
};


export type QueryTestArgs = {
  anyKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestAddressAvailableForDeliveryArgs = {
  geo_lat: Scalars['String']['input'];
  geo_lon: Scalars['String']['input'];
};


export type QueryTestAsyncArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestAsyncAwaitArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestAttachArgs = {
  filter?: Scalars['String']['input'];
  productId: Scalars['Float']['input'];
};


export type QueryTestFieldsArgs = {
  cookieId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestGetArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestLoggerArgs = {
  value?: Scalars['String']['input'];
};


export type QueryTestRedConnectionArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestSendEmailArgs = {
  emailType?: EmailTypes;
  notificationEvent?: InputMaybe<NotificationEventEnum>;
  peopleId?: InputMaybe<Scalars['Int']['input']>;
  promocodeId?: InputMaybe<Scalars['Int']['input']>;
  reviewId?: InputMaybe<Scalars['Int']['input']>;
  sendAll?: Scalars['Boolean']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
  toEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTestSendNotificationArgs = {
  isDestroyCatalogSubscribers?: Scalars['Boolean']['input'];
  notificationEvent: NotificationEventEnum;
  subscribersIds: Array<Scalars['Int']['input']>;
};


export type QueryTestTimeCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestVarLogArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTesttypeByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUploadImgArgs = {
  achivement_id?: Scalars['String']['input'];
  headerToken?: Scalars['String']['input'];
  people?: Scalars['String']['input'];
};


export type QueryUploadImg1Args = {
  achivement_id?: Scalars['String']['input'];
  headerToken?: Scalars['String']['input'];
  people?: Scalars['String']['input'];
};


export type QueryUploadImg2Args = {
  achivement_id?: Scalars['String']['input'];
  headerToken?: Scalars['String']['input'];
  people?: Scalars['String']['input'];
};

export type ReciepeToFavoritesInput = {
  /** Id рецепта */
  objectId?: InputMaybe<Scalars['Float']['input']>;
};

export type RecipesAuthorModel = {
  __typename?: 'RecipesAuthorModel';
  active?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userItem?: Maybe<UsersModel>;
  user_id?: Maybe<Scalars['Int']['output']>;
  vk?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type RecipesBludoModel = {
  __typename?: 'RecipesBludoModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesCommentsModel = {
  __typename?: 'RecipesCommentsModel';
  active?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerUserItem?: Maybe<UsersModel>;
  answer_date?: Maybe<Scalars['DateTimeISO']['output']>;
  answer_user_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  getCustomFields?: Maybe<CommentsUnion>;
  getPeopleAvatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item_id?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<CommentsPhotosUnion>>;
  rating?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type RecipesIngredientsInput = {
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type RecipesIngredientsItemsModel = {
  __typename?: 'RecipesIngredientsItemsModel';
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ingredientItems?: Maybe<RecipesIngredientsModel>;
  ingredient_id?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesIngredientsModel = {
  __typename?: 'RecipesIngredientsModel';
  id: Scalars['ID']['output'];
  ingredientsItems?: Maybe<Array<RecipesIngredientsItemsModel>>;
  is_promo?: Maybe<Scalars['Float']['output']>;
  recipeItems?: Maybe<RecipesModel>;
  recipes_id?: Maybe<Scalars['Int']['output']>;
  timeid?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesInput = {
  author: Scalars['String']['input'];
  bludo_id: Scalars['Float']['input'];
  cooking_time: Scalars['Float']['input'];
  file_id?: InputMaybe<Scalars['Float']['input']>;
  naznachenie_id: Scalars['Float']['input'];
  obrabotka_id: Scalars['Float']['input'];
  serving: Scalars['Float']['input'];
  slozhnost_id: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type_id: Scalars['Float']['input'];
  video_code?: InputMaybe<Scalars['String']['input']>;
  video_id?: InputMaybe<Scalars['Float']['input']>;
};

export type RecipesInstructionInput = {
  file_id?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type RecipesInstructionModel = {
  __typename?: 'RecipesInstructionModel';
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  is_final?: Maybe<Scalars['Float']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  recipeItems?: Maybe<RecipesModel>;
  recipes_id?: Maybe<Scalars['Int']['output']>;
  timeid?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};


export type RecipesInstructionModelMainImageArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesModel = {
  __typename?: 'RecipesModel';
  /** оценки сложности рецепта - показывает голосовал ли текущий пользователь  и какую оценку поставил. Если да, то показывается эту оценку в скобочках под общей средней */
  _votedDifficult?: Maybe<Scalars['Float']['output']>;
  /** оценки рейтинга рецепта - показывает голосовал ли текущий пользователь и какую оценку поставил. Если да, то показывается эту оценку в скобочках под общей средней */
  _votedRating?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  author?: Maybe<Scalars['String']['output']>;
  authorItem?: Maybe<RecipesAuthorModel>;
  author_id?: Maybe<Scalars['Int']['output']>;
  bludoItem?: Maybe<RecipesBludoModel>;
  bludo_id?: Maybe<Scalars['Int']['output']>;
  bobrabotkaItem?: Maybe<RecipesObrabotkaModel>;
  calories?: Maybe<Scalars['Float']['output']>;
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  comments_number?: Maybe<Scalars['Float']['output']>;
  cooking_time?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Сумма цен товаров (кроме уже выбранного товара) для проморецепта для функции getPromoRecipesByProductId */
  extraPrice?: Maybe<Scalars['Float']['output']>;
  fat?: Maybe<Scalars['Float']['output']>;
  favoritesItems?: Maybe<Array<FavoritesModel>>;
  file_id?: Maybe<Scalars['Int']['output']>;
  getFile?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  identifyIdURI?: Maybe<Scalars['String']['output']>;
  /** В избранном рецепт или нет */
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  is_product_promo?: Maybe<Scalars['Float']['output']>;
  modified_at?: Maybe<Scalars['DateTimeISO']['output']>;
  naznachenieItem?: Maybe<RecipesNaznachenieModel>;
  naznachenie_id?: Maybe<Scalars['Int']['output']>;
  obrabotka_id?: Maybe<Scalars['Int']['output']>;
  onmain?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  protein?: Maybe<Scalars['Float']['output']>;
  /** Показывает общий(средний) рейтинг, в отличии от поля _votedRating, которое показывает голосовал ли текущий пользователь  и какую оценку поставил. Если да, то показывается и то и то значение основное занчениеЖ общий рейтинг - подпись оценка пользователя например ХОРОШИЙ(ВАШ ГОЛОС — ПЛОХОЙ) https://yadi.sk/i/BtvHFYybRncbuw */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Количество голосов за рейтинг рецепта */
  rating_votes?: Maybe<Scalars['Float']['output']>;
  recipeIngredients?: Maybe<Array<RecipesIngredientsModel>>;
  recipeInstructions?: Maybe<Array<RecipesInstructionModel>>;
  /** Тоже самое что и slozhnost_id */
  recipes_difficult?: Maybe<Scalars['Int']['output']>;
  relProfile?: Maybe<Array<RecipesRelationsModel>>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  serving?: Maybe<Scalars['Float']['output']>;
  /** Сущность, содержащая общую(средную) оценку сложности рецепта, в отличии от поля _votedDifficult, которое показывает голосовал ли текущий пользователь и какую оценку поставил. Если да, то после оценки показывается оба значения: усредненное и оценка пользователя например ХОРОШИЙ(ВАШ ГОЛОС — ПЛОХОЙ) https://yadi.sk/i/z5zLgNcDV-ZoCw */
  slozhnostItem?: Maybe<RecipesSlozhnostModel>;
  slozhnost_id?: Maybe<Scalars['Int']['output']>;
  /** Количество голосов за сложность рецепта */
  slozhnost_votes?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  tip?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type_id?: Maybe<Scalars['Int']['output']>;
  typesItem?: Maybe<RecipesTypesModel>;
  video_code?: Maybe<Scalars['String']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
  video_title?: Maybe<Scalars['String']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  zen_description?: Maybe<Scalars['String']['output']>;
  zen_media_rating?: Maybe<Scalars['Int']['output']>;
};

export type RecipesNaznachenieModel = {
  __typename?: 'RecipesNaznachenieModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['String']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type RecipesObrabotkaModel = {
  __typename?: 'RecipesObrabotkaModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesRelationsModel = {
  __typename?: 'RecipesRelationsModel';
  article_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Float']['output']>;
  people_profile_id?: Maybe<Scalars['Float']['output']>;
  profileItem: PeopleProfileModel;
  recipe_id?: Maybe<Scalars['Float']['output']>;
  video_article_id?: Maybe<Scalars['Float']['output']>;
};

export type RecipesSlozhnostModel = {
  __typename?: 'RecipesSlozhnostModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesTypesModel = {
  __typename?: 'RecipesTypesModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesUnion = {
  __typename?: 'RecipesUnion';
  bludoItems?: Maybe<Array<RecipesBludoModel>>;
  naznachenieItems?: Maybe<Array<RecipesNaznachenieModel>>;
  obrabotkaItems?: Maybe<Array<RecipesObrabotkaModel>>;
  promoBludoItems?: Maybe<Array<RecipesBludoModel>>;
  promoBludoProducts?: Maybe<Array<CatalogModel>>;
  recipeCommentsItem?: Maybe<Array<RecipesCommentsModel>>;
  recipeItems?: Maybe<Array<RecipesModel>>;
  slozhnostItems?: Maybe<Array<RecipesSlozhnostModel>>;
  totalCount: Scalars['Int']['output'];
  typesItems?: Maybe<Array<RecipesTypesModel>>;
};

export type RedirectsModel = {
  __typename?: 'RedirectsModel';
  comment?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  is_active?: Maybe<Scalars['Float']['output']>;
  is_not_found?: Maybe<Scalars['Float']['output']>;
  uri_from?: Maybe<Scalars['String']['output']>;
  uri_to?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

export type RefundCommentListModel = {
  __typename?: 'RefundCommentListModel';
  active?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type RefundRelationsModel = {
  __typename?: 'RefundRelationsModel';
  commentItem?: Maybe<RefundCommentListModel>;
  comment_id?: Maybe<Scalars['Int']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  refund_id?: Maybe<Scalars['Int']['output']>;
};

export type RegisterInput = {
  courierId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  fio?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  password: Scalars['String']['input'];
};

export type ReplyUnion = {
  __typename?: 'ReplyUnion';
  caches?: Maybe<Array<Caches>>;
  data?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_sent?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Errors>>;
  info?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  promocode?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

/** Кому предназначен отзыв <br>FOR_COURIER - "Курьеру" <br>FOR_MANAGER - "Менеджеру заказа" <br>FOR_LOYALTY_MANAGER - "Менеджеру лояльности" <br>FOR_CHEF - "Шеф-повару" <br>FOR_DIRECTOR - "Директору" */
export enum ReviewForWhomEnum {
  ForChef = 'FOR_CHEF',
  ForCourier = 'FOR_COURIER',
  ForDirector = 'FOR_DIRECTOR',
  ForLoyaltyManager = 'FOR_LOYALTY_MANAGER',
  ForManager = 'FOR_MANAGER'
}

export type ReviewInput = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** массив с id, загруженных файлов */
  filesIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** ФИО автора отзыва */
  fio?: InputMaybe<Scalars['String']['input']>;
  /** Оценка: обязательно в случае «поблагодарить» и «пожаловаться» */
  fiveStarRating?: InputMaybe<Scalars['Float']['input']>;
  /** Для кого: обязательно в случае «поблагодарить» и «пожаловаться», не нужен в случае с «предложить» */
  forWhom?: InputMaybe<ReviewForWhomEnum>;
  /** Связь с заказом */
  orderId?: InputMaybe<Scalars['Float']['input']>;
  /** Номер телефона */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** источник отзыва */
  source?: InputMaybe<ReviewSourceEnum>;
  /** массив с id тегов */
  tags?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Текст отзыва */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<ReviewTypeEnum>;
  /** id отзыва на Яндекс Маркете */
  yandexMarketId?: InputMaybe<Scalars['String']['input']>;
};

/** Сортировка: <br>NEW - "Самые свежие" <br>OLD - "Cамые давние" */
export enum ReviewSortEnum {
  New = 'NEW',
  Old = 'OLD'
}

/** Источник: <br>D - "Деликатеска" <br>YM - "Яндекс.Маркет" */
export enum ReviewSourceEnum {
  D = 'D',
  Ym = 'YM'
}

/** Тип: <br>THANKS - "Поблагодарить" <br>COMPLAINT - "Пожаловаться" <br>OFFER - "Предложить" */
export enum ReviewTypeEnum {
  Complaint = 'COMPLAINT',
  Offer = 'OFFER',
  Thanks = 'THANKS'
}

export type ReviewVoteInput = {
  /** Id отзыва */
  objectId?: InputMaybe<Scalars['Float']['input']>;
  /** Полезен ли отзыв */
  useful?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ReviewabilityStatus {
  LastOrderReviewed = 'LastOrderReviewed',
  NotBought = 'NotBought',
  Reviewable = 'Reviewable'
}

export type ReviewsHistoryModel = {
  __typename?: 'ReviewsHistoryModel';
  active?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerUserItem?: Maybe<UsersModel>;
  answer_date?: Maybe<Scalars['DateTimeISO']['output']>;
  answer_user_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Float']['output']>;
  photos?: Maybe<Array<CommentsPhotosUnion>>;
  rating?: Maybe<Scalars['Float']['output']>;
  review_id?: Maybe<Scalars['Float']['output']>;
  tagList?: Maybe<Array<ReviewsTagsModel>>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReviewsModel = {
  __typename?: 'ReviewsModel';
  _voted?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerUserItem?: Maybe<UsersModel>;
  answer_date?: Maybe<Scalars['DateTimeISO']['output']>;
  answer_rating?: Maybe<Scalars['Float']['output']>;
  answer_rating_text?: Maybe<Scalars['String']['output']>;
  answer_user_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  for_whom?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCanEdit?: Maybe<Scalars['Boolean']['output']>;
  isCanRateAnswer?: Maybe<Scalars['Boolean']['output']>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<CommentsPhotosUnion>>;
  rating?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tagList?: Maybe<Array<ReviewsTagsModel>>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  votes_no?: Maybe<Scalars['Float']['output']>;
  votes_yes?: Maybe<Scalars['Float']['output']>;
  ym_id?: Maybe<Scalars['String']['output']>;
};

export type ReviewsTagsModel = {
  __typename?: 'ReviewsTagsModel';
  active: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  sort: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReviewsUnion = {
  __typename?: 'ReviewsUnion';
  reviewsItems?: Maybe<Array<ReviewsModel>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SbpDataReplyUnion = {
  __typename?: 'SBPDataReplyUnion';
  /** банки */
  data?: Maybe<DataUnion>;
  /** ошибка api */
  error?: Maybe<Scalars['String']['output']>;
  /** код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** ошибки */
  errors?: Maybe<Array<ApiErrorUnion>>;
};

export type SbpReplyUnion = {
  __typename?: 'SBPReplyUnion';
  /** сбп_дата */
  apiResponse?: Maybe<SbpDataReplyUnion>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type SaleSectionProductsReplyUnion = {
  __typename?: 'SaleSectionProductsReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** кол-во минут между сегодня и ближайшим днем доставки БЕЗ учета планового отключения */
  minBeforeDeliveryClosed?: Maybe<Scalars['Float']['output']>;
  /** кол-во минут между сегодня и ближайшим днем доставки С учетом планового отключения */
  minBeforeDeliveryClosedWithBlock?: Maybe<Scalars['Float']['output']>;
  /** заказ */
  productsIds?: Maybe<Array<Scalars['Float']['output']>>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type ScheduleItem = {
  __typename?: 'ScheduleItem';
  days: Scalars['String']['output'];
  hours: Scalars['String']['output'];
};

export type SearchBoosterPopularCategory = {
  __typename?: 'SearchBoosterPopularCategory';
  category?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SearchBoosterPopularQueriesAndCategories = {
  __typename?: 'SearchBoosterPopularQueriesAndCategories';
  categories?: Maybe<Array<SearchBoosterPopularCategory>>;
  queries?: Maybe<Array<SearchBoosterPopularQuery>>;
};

export type SearchBoosterPopularQuery = {
  __typename?: 'SearchBoosterPopularQuery';
  count?: Maybe<Scalars['Int']['output']>;
  query?: Maybe<Scalars['String']['output']>;
};

export type SearchExamplesReplyUnion = {
  __typename?: 'SearchExamplesReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Строка подсказки поиска */
  searchExamples?: Maybe<Array<Scalars['String']['output']>>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type SearchQueriesModel = {
  __typename?: 'SearchQueriesModel';
  id: Scalars['Int']['output'];
  last_query_datetime?: Maybe<Scalars['DateTimeISO']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  query_count?: Maybe<Scalars['Float']['output']>;
};

export type ServicesModel = {
  __typename?: 'ServicesModel';
  catalogRubrics?: Maybe<Array<CatalogTypesModel>>;
  created_at?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasDescription: Scalars['Boolean']['output'];
  has_related_products?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Float']['output']>;
  is_group?: Maybe<Scalars['Float']['output']>;
  is_hidden?: Maybe<Scalars['Float']['output']>;
  is_multiple?: Maybe<Scalars['Float']['output']>;
  is_service_and_subscription_same_time?: Maybe<Scalars['Float']['output']>;
  maxQuantityInOrder?: Maybe<Scalars['Int']['output']>;
  max_quantity_in_order?: Maybe<Scalars['Float']['output']>;
  min_order_price_gold?: Maybe<Scalars['Float']['output']>;
  min_order_price_nominal?: Maybe<Scalars['Float']['output']>;
  min_order_price_silver?: Maybe<Scalars['Float']['output']>;
  modified_at?: Maybe<Scalars['DateTimeISO']['output']>;
  multiple?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceWithSubscription?: Maybe<Scalars['Int']['output']>;
  price_with_subscription?: Maybe<Scalars['Float']['output']>;
  servicesModel: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  short_description_with_subscription?: Maybe<Scalars['String']['output']>;
  sorting_weight?: Maybe<Scalars['Float']['output']>;
  subscriptionPeriod?: Maybe<Scalars['Int']['output']>;
  subscription_period?: Maybe<Scalars['Float']['output']>;
  subscription_price?: Maybe<Scalars['Float']['output']>;
  svg_code?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type_id?: Maybe<Scalars['Float']['output']>;
};

export type SetOrderPaymentTypeUnion = {
  __typename?: 'SetOrderPaymentTypeUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Заказ */
  orderItem?: Maybe<OrdersModel>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type SettingsInput = {
  catalog_sorting?: InputMaybe<Scalars['String']['input']>;
  epp_catalog?: InputMaybe<Scalars['Float']['input']>;
  is_order_notify_messengers?: InputMaybe<Scalars['Float']['input']>;
  is_order_notify_sms?: InputMaybe<Scalars['Float']['input']>;
  newLoyaltyProgram?: InputMaybe<Scalars['String']['input']>;
};

export type ShopModel = {
  __typename?: 'ShopModel';
  address?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<StoresAttachmentsModel>>;
  geo?: Maybe<Array<Scalars['Float']['output']>>;
  icon_list?: Maybe<Scalars['String']['output']>;
  icon_map?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<AttachmentsModel>>;
  images_landing?: Maybe<Array<AttachmentsModel>>;
  metroStations?: Maybe<Array<MetroStationsModel>>;
  nearestDelivery?: Maybe<CatalogDeliveryUnion>;
  opens_soon?: Maybe<Scalars['Boolean']['output']>;
  oyster_bar?: Maybe<Scalars['Boolean']['output']>;
  paymentTypes?: Maybe<Array<OrdersPaymentsModel>>;
  phone?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  schedule?: Maybe<Array<ScheduleItem>>;
  tips?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ShopType>;
  ya_maps_url?: Maybe<Scalars['String']['output']>;
};

export enum ShopType {
  Cafe = 'cafe',
  OysterBar = 'oyster_bar',
  Shop = 'shop'
}

export type SocialActionReplyUnion = {
  __typename?: 'SocialActionReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Ссылка для перехода при ошибке */
  location?: Maybe<Scalars['String']['output']>;
  /** Пользователь */
  people?: Maybe<PeopleModel>;
  /** Регистрация пользователя */
  registered?: Maybe<Scalars['Boolean']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type SocialDataInput = {
  /** ключ */
  accessToken?: InputMaybe<Scalars['String']['input']>;
  /** ключ */
  access_token?: InputMaybe<Scalars['String']['input']>;
  auth?: InputMaybe<Scalars['Boolean']['input']>;
  /** код авторизации, используется для авторизации в ok.ru */
  code?: InputMaybe<Scalars['String']['input']>;
  /** время в формате Unixtime, когда сессия устареет */
  expire?: InputMaybe<Scalars['Float']['input']>;
  /** имя */
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** служебный параметр, необходимый для проверки авторизации на удаленной стороне. */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** фамилия */
  last_name?: InputMaybe<Scalars['String']['input']>;
  /** uid из vk / Id пользователя */
  mid?: InputMaybe<Scalars['Float']['input']>;
  /** nickname */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** служебный параметр, необходимый для проверки авторизации на удаленной стороне. */
  secret?: InputMaybe<Scalars['String']['input']>;
  /** служебный параметр, необходимый для проверки авторизации на удаленной стороне. */
  sid?: InputMaybe<Scalars['String']['input']>;
  /** служебный параметр, необходимый для проверки авторизации на удаленной стороне. */
  sig?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Float']['input']>;
  validAccessToken?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Выбрать тип для комментария: отзыв о магазине/товаре */
export enum StoreOrProductCommentsTypeEnum {
  ProductReview = 'ProductReview',
  StoreReview = 'StoreReview'
}

export type StoreScheduleModel = {
  __typename?: 'StoreScheduleModel';
  day?: Maybe<Scalars['Int']['output']>;
  end_time?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  max_time?: Maybe<Scalars['Float']['output']>;
  start_time?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

export type StoresAttachmentsModel = {
  __typename?: 'StoresAttachmentsModel';
  description?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<AttachmentsModel>;
  store?: Maybe<StoresModel>;
  store_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<StoresAttachmentsType>;
  weight?: Maybe<Scalars['Int']['output']>;
};

/** размер изображения для разных целей на сайте */
export enum StoresAttachmentsType {
  Landing = 'landing',
  Modal = 'modal'
}

export type StoresCityModel = {
  __typename?: 'StoresCityModel';
  active?: Maybe<Scalars['Int']['output']>;
  default_store_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_default?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StoresFieldsModel = {
  __typename?: 'StoresFieldsModel';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StoresModel = {
  __typename?: 'StoresModel';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  amount_store?: Maybe<Scalars['Int']['output']>;
  city_id?: Maybe<Scalars['Int']['output']>;
  coord?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<StoresFieldsModel>>;
  has_amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<StoresAttachmentsModel>>;
  is_delivery?: Maybe<Scalars['Int']['output']>;
  is_pickup?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentItems?: Maybe<Array<OrdersPaymentsModel>>;
  point?: Maybe<Scalars['String']['output']>;
  scheduleItems?: Maybe<Array<StoreScheduleModel>>;
  shop?: Maybe<ShopModel>;
  type?: Maybe<Scalars['String']['output']>;
  zones?: Maybe<StoresZonesModel>;
};

export type StoresProductPricesModel = {
  __typename?: 'StoresProductPricesModel';
  id?: Maybe<Scalars['Int']['output']>;
  price_active?: Maybe<Scalars['Float']['output']>;
  price_current?: Maybe<Scalars['Float']['output']>;
  price_retail?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

export type StoresZonesModel = {
  __typename?: 'StoresZonesModel';
  active?: Maybe<Scalars['Int']['output']>;
  aggregate?: Maybe<Scalars['String']['output']>;
  close_type?: Maybe<Scalars['String']['output']>;
  free_price?: Maybe<Scalars['Int']['output']>;
  has_intervals?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  min_interval?: Maybe<Scalars['Int']['output']>;
  min_price?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  time_delivery?: Maybe<Scalars['Int']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type StoriesModel = {
  __typename?: 'StoriesModel';
  active?: Maybe<Scalars['Int']['output']>;
  alreadyWatched?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  slides?: Maybe<Array<StoriesSlidesModel>>;
  sort?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StoriesSlidesModel = {
  __typename?: 'StoriesSlidesModel';
  active?: Maybe<Scalars['Int']['output']>;
  alreadyWatched?: Maybe<Scalars['Boolean']['output']>;
  button_color?: Maybe<Scalars['String']['output']>;
  button_link?: Maybe<Scalars['String']['output']>;
  button_title?: Maybe<Scalars['String']['output']>;
  button_title_color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  delay?: Maybe<Scalars['Int']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  file_link?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  story_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  text_color?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SubscribeExistingUnion = {
  __typename?: 'SubscribeExistingUnion';
  email?: Maybe<Scalars['String']['output']>;
  sms?: Maybe<Scalars['String']['output']>;
  subscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscribeUserUnion = {
  __typename?: 'SubscribeUserUnion';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SubscribersModel = {
  __typename?: 'SubscribersModel';
  active?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Scalars['String']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  average_check?: Maybe<Scalars['Float']['output']>;
  bill?: Maybe<Scalars['Float']['output']>;
  birthday?: Maybe<Scalars['DateTimeISO']['output']>;
  caviar_black?: Maybe<Scalars['String']['output']>;
  caviar_red?: Maybe<Scalars['String']['output']>;
  chilled_fish?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coordinator?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  date_order_first?: Maybe<Scalars['DateTimeISO']['output']>;
  date_order_last?: Maybe<Scalars['DateTimeISO']['output']>;
  date_reg?: Maybe<Scalars['DateTimeISO']['output']>;
  dishes?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  healthy_eating?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_newbee?: Maybe<Scalars['String']['output']>;
  is_waiting?: Maybe<Scalars['Float']['output']>;
  italian?: Maybe<Scalars['String']['output']>;
  japanese?: Maybe<Scalars['String']['output']>;
  live_seafood?: Maybe<Scalars['String']['output']>;
  meat?: Maybe<Scalars['String']['output']>;
  mexican?: Maybe<Scalars['String']['output']>;
  mushrooms?: Maybe<Scalars['String']['output']>;
  novelty?: Maybe<Scalars['String']['output']>;
  orders_per_month?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  promo?: Maybe<Scalars['String']['output']>;
  recipes?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_orders?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

export type SubscribersUnion = {
  __typename?: 'SubscribersUnion';
  currentUser?: Maybe<SubscribeUserUnion>;
  peopleSubscription?: Maybe<PeopleSubscribtionUnion>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscribesInput = {
  novelty?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  recipes?: InputMaybe<Scalars['String']['input']>;
  testDrive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskModel = {
  __typename?: 'TaskModel';
  amount?: Maybe<Scalars['Float']['output']>;
  days?: Maybe<Scalars['Float']['output']>;
  daysLeft?: Maybe<Scalars['Float']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  link_title?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  peopleTasks?: Maybe<Array<TaskPeopleModel>>;
  products?: Maybe<Array<Scalars['Float']['output']>>;
  rulesItem?: Maybe<Array<TaskRuleModel>>;
  sort?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TaskPeopleModel = {
  __typename?: 'TaskPeopleModel';
  date_end?: Maybe<Scalars['DateTimeISO']['output']>;
  date_start?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  status_id?: Maybe<Scalars['Int']['output']>;
  taskItem?: Maybe<TaskModel>;
  taskStatusItem?: Maybe<TaskPeopleStatusModel>;
  task_id?: Maybe<Scalars['Int']['output']>;
};

export type TaskPeopleStatusModel = {
  __typename?: 'TaskPeopleStatusModel';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type TaskRuleModel = {
  __typename?: 'TaskRuleModel';
  additional?: Maybe<Scalars['String']['output']>;
  expression?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  period_from?: Maybe<Scalars['Float']['output']>;
  period_to?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  taskItem?: Maybe<TaskModel>;
  task_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_rule?: Maybe<Scalars['String']['output']>;
};

export type TasksReplyUnion = {
  __typename?: 'TasksReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** задания */
  task?: Maybe<TasksUnion>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type TasksUnion = {
  __typename?: 'TasksUnion';
  /** доступные задания */
  access?: Maybe<Array<TaskModel>>;
  /** завершенные задания */
  complete?: Maybe<Array<TaskModel>>;
  /** текущие задания */
  progress?: Maybe<Array<TaskModel>>;
};

export type TestDriveModel = {
  __typename?: 'TestDriveModel';
  active?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  bids?: Maybe<Scalars['Float']['output']>;
  catalogItems?: Maybe<Array<CatalogModel>>;
  comments?: Maybe<Array<CatalogCommentsModel>>;
  commentsCount?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<PeopleModel>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  descr_cart?: Maybe<Scalars['String']['output']>;
  descriptionForCart?: Maybe<Scalars['String']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  min_sum?: Maybe<Scalars['Float']['output']>;
  ordersItems?: Maybe<Array<OrdersTestDrivesModel>>;
  peopleCount?: Maybe<Scalars['Int']['output']>;
  peopleStatus?: Maybe<PeopleStatusModel>;
  people_status_id?: Maybe<Scalars['Float']['output']>;
  produtImages?: Maybe<Array<Scalars['String']['output']>>;
  relatedPeople?: Maybe<Array<Scalars['String']['output']>>;
  relatedPeopleFromOrders?: Maybe<Array<PeopleModel>>;
  /** Есть ли пользователь, открывший карточку ТД, в списке участников */
  requested?: Maybe<Scalars['Boolean']['output']>;
  testDriveRelations?: Maybe<Array<TestDriveRelationsModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleForCart?: Maybe<Scalars['String']['output']>;
  title_cart?: Maybe<Scalars['String']['output']>;
  uncommentedProducts?: Maybe<Array<CatalogModel>>;
};

export type TestDriveRelationsModel = {
  __typename?: 'TestDriveRelationsModel';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_tested?: Maybe<Scalars['Float']['output']>;
  catalogItem: CatalogModel;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  peopleItem: PeopleModel;
  people_id?: Maybe<Scalars['Int']['output']>;
  testCatalogItem: CatalogModel;
  testDriveItem: TestDriveModel;
  testOrderItem: OrdersModel;
  test_catalog_id?: Maybe<Scalars['Int']['output']>;
  test_date?: Maybe<Scalars['DateTimeISO']['output']>;
  test_order_id?: Maybe<Scalars['Int']['output']>;
};

export type TestDriveStatsUnion = {
  __typename?: 'TestDriveStatsUnion';
  catlogItems?: Maybe<Array<CatalogModel>>;
  isValidForNewTestDrive?: Maybe<Scalars['Boolean']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TestDriveSubscribersModel = {
  __typename?: 'TestDriveSubscribersModel';
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  subscribed?: Maybe<Scalars['Float']['output']>;
};

export type TestDriveUnion = {
  __typename?: 'TestDriveUnion';
  testDriveItems?: Maybe<Array<TestDriveModel>>;
  testDrivesCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Tips = {
  __typename?: 'Tips';
  label?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
};

export type TopMenuModel = {
  __typename?: 'TopMenuModel';
  active?: Maybe<Scalars['Float']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  icon_2x?: Maybe<Scalars['String']['output']>;
  icon_3x?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  link?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TopMenuSpecialModel = {
  __typename?: 'TopMenuSpecialModel';
  active?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_color?: Maybe<Scalars['String']['output']>;
};

export type UploadUnion = {
  __typename?: 'UploadUnion';
  height: Scalars['String']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['String']['output'];
  type: Scalars['String']['output'];
  video: Scalars['String']['output'];
  width: Scalars['String']['output'];
};

export type UsersModel = {
  __typename?: 'UsersModel';
  active?: Maybe<Scalars['String']['output']>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  medkn_id?: Maybe<Scalars['Float']['output']>;
  midname?: Maybe<Scalars['String']['output']>;
  min_auth_time?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  secondname?: Maybe<Scalars['String']['output']>;
};

export type VacancyModel = {
  __typename?: 'VacancyModel';
  additionalRequirements?: Maybe<Scalars['String']['output']>;
  additionalResponsibilities?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  getDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  mainRequirements?: Maybe<Scalars['String']['output']>;
  mainResponsibilities?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
  status: Scalars['Float']['output'];
};

export type VacancyReplyUnion = {
  __typename?: 'VacancyReplyUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  vacancy?: Maybe<VacancyModel>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type VideosUnion = {
  __typename?: 'VideosUnion';
  id?: Maybe<Scalars['String']['output']>;
  thumbnail_height?: Maybe<Scalars['Int']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  thumbnail_width?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VoteForArticleInput = {
  /** Id статьи */
  articleId?: InputMaybe<Scalars['Float']['input']>;
  /** оценка статьи */
  fiveStarRating?: InputMaybe<Scalars['Float']['input']>;
};

export type VoteForRecipeInput = {
  /** флаг для оценки сложности рецепта */
  complexity?: InputMaybe<Scalars['Boolean']['input']>;
  /** оценка рейтинга или сложности рецепта */
  fiveStarRating?: InputMaybe<Scalars['Float']['input']>;
  /** Id рецепта */
  recipeId?: InputMaybe<Scalars['Float']['input']>;
};

export type YouTubeUnion = {
  __typename?: 'YouTubeUnion';
  id?: Maybe<Scalars['String']['output']>;
  thumbnail_height?: Maybe<Scalars['Int']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  thumbnail_width?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** фильтр заказов 'ALL', 'DELIVERY', 'SHOP', 'MENU', 'MENU_TODAY', 'DELETED' */
export enum GetPeopleOrdersFilters {
  All = 'ALL',
  Deleted = 'DELETED',
  Delivery = 'DELIVERY',
  Menu = 'MENU',
  MenuToday = 'MENU_TODAY',
  Shop = 'SHOP'
}

export type GetProductsBySupplierIdUnion = {
  __typename?: 'getProductsBySupplierIdUnion';
  catalogItem?: Maybe<Array<CatalogModel>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SmsInput = {
  is_order_notify_messengers?: InputMaybe<Scalars['Boolean']['input']>;
  is_order_notify_sms?: InputMaybe<Scalars['Boolean']['input']>;
  need_digital_receipt?: InputMaybe<Scalars['Boolean']['input']>;
};

/** тип действия с подпиской */
export enum SubscribtionAction {
  Add = 'ADD',
  Delete = 'DELETE'
}
